//Simplified Chinese
export const language = {
    //2020-10-26-ljm增加 弹窗提示以及翻译
    meassage:{
        leanMore:'了解更多',
        skip:'跳过',
        activate:'激活',
        emailSend: 'Email sent!',
    },
leftBanner: {
    liteFile: 'Lite File',
    logoSlogan: '跨云盘传输的首选工具',
    cloudEscription: '跨云数据传输，就选MultCloud',
    commonTools: '常用工具',
    cloudDrives: '我的云盘',
    onlineServices: '我的在线服务',
    switchTxt: '切换至经典界面',
    taskList: '任务列表',
    cloudTransfer: '跨云盘传输',
    cloudSync: '跨云盘同步',
    cloudBackup:'云备份',
    btLink: '离线上传',
    teamTransfer:'企业云盘传输',
    shares: '分享管理',
    emailTransfer: '邮件传输',
    instagramDownload: 'Instagram 下载器',
    videoDownload: '视频下载器',
    webDownload: '网页图片下载器',
    addCloud: 'Add Cloud',
    addEmail: 'Add Email',
    encryption: '加密功能',
    edit: '重新添加',
    remove: '移除',
    createTask: '新建任务',
    createTaskText: '您可以在此创建任务',
    gotIt: '知道了',
    bigWriteEncrypt: '加密',
    encryptionText: '您可以在此加密云盘文件。',
    addCloudText: '点击这里将您的云盘和邮箱添加到MultCloud。',
    inviteFriends: '邀请好友',
    switchTip:'切换到经典版',
    switchTipDes:'您可以在此切换到经典版。',
    new: '新',
},
common: {
    addCloud: '添加云盘',
    addEmail: '添加邮箱',
    options: '选项',
    schedule: '定时任务',
    ok: '确定',
    save: '保存',
    add: '添加',
    upgradeNow: '立即订阅',
    from: '来源',
    to: '目标',
    result: '结果',
    fileProcess: '文件进度',
    transferFiles:'文件',
    dataProcess: '数据进度',
    startTime: '开始时间',
    currentRate: '当前速度',
    endTime: '结束时间',
    timeRemaining: '剩余时间',
    averageRate: '平均速度',
    averageRateSpecial: '平均速度',
    viewFailed: '点击查看失败文件',
    fileSuccess: '成功传输所有文件',
    size: '大小',
    executedTimes: '执行次数',
    sourceDir: '源目录',
    cause: '原因',
    retry: '重试',
    retryMin: '重试',
    clean: '清除',
    properties: '属性',
    copy: '复制',
    move: '移动',
    multiSelect: '多选',
    close: '关闭',
    copyTo: '复制到',
    tranTo: '传输到',
    syncWith: '同步到',
    backupTo: '备份到',
    download: '下载',
    delete: '删除',
    more: '更多',
    preview: '预览',
    share: '分享',
    shareWith: '用MultCloud分享',
    shareTransfer: '创建一个传输',
    encrypt: '加密',
    encryptFile: '只加密文件',
    encryptFileName: '加密文件与文件名',
    decrypt: '解密',
    decryptFile: '只解密文件',
    decryptFileName: '解密文件与文件名',
    onedriveBusinessContentNote: '注意',
    oneDrive4BusinessContent: '如果您是管理员，并且已经为用户分配了 Microsoft 365 许可证，但在通过 MultCloud 访问用户文件夹时收到“访问被拒绝”错误，请尝试以下步骤：',
    oneDrive4BusinessTips1: `转到“<a href="https://admin.microsoft.com/" target="_blank" class='add-onedrivebuiness-link'>管理</a>”。选择“用户” > “激活用户” > 选择“管理产品许可证”。`,
    oneDrive4BusinessTips2: '转到“OneDrive”选项卡，点击“创建文件链接”。然后，返回MultCloud并尝试再次访问该账户。',
    oneDrive4BusinessStep1: '步骤1',
    oneDrive4BusinessStep2: '步骤2',
    upStep: '上一步',
    nextStep: '下一步',
    complete: '完成',
    cut: '剪切',
    viewDetails: '查看详情',
    toOfficialSite: '官网',
    btLinkTask: '离线任务',
    fileName: '文件名',
    itemsSelected: '已选项目',
    dateModified: '修改日期',
    rename: '重命名',
    paste: '粘贴',
    btLink: '离线上传',
    load: '加载中',
    status: '状态',
    operate: '操作',
    failure: '失败',
    link: '复制链接',
    cleanList: '清除历史记录',
    type: '类型',
    account: '账号',
    name: '文件名',
    selectFailedFile: '请选择失败文件',
    transferring: '传输中',
    newPassword: '新密码',
    confirmPassword: '确认密码',
    done: '完成',
    no: '否',
    yes: '是',
    attention: '注意',
    cancel: '取消',
    unsubscribe: '取消订阅',
    reactivate: '重新激活',
    sureCleanAll: '您确定要清除所有完成的任务吗?',
    failedFiles: '失败文件',
    minTo: '到',
    retryAll: '全部重传',
    viewProgress: '查看进度',
    taskNotRun: '此任务未执行。',
    success: '成功',
    failure: '失败',
    canceled: '取消',
    patial: '部分成功',
    syncDetails: '同步详情',
    width: '宽度',
    sync: '同步',
    targetCloud: '目标云盘',
    running: '执行中',
    preparing: '准备中',
    waiting: '等待中',
    target: '目标',
    noVip: '目前您最多只能同时传输2个文件，升级成为订阅用户可同时传输10个文件！',
    vipThanks: '感谢您订阅我们的服务，您最多可以同时传输10个文件。',
    emailAccount: '电子邮箱账号',
    with: '目标',
    syncing: '同步中',
    selectAll: '全选',
    date: '日期',
    failed: '失败',
    skip: '跳过',
    replace: '覆盖',
    ready: '就绪',
    connecting: '连接中',
    account: '账号',
    selectNull: '请选择目标目录。',
    selectOther: '无法选择该目录来粘贴文件，可以选择其子目录或其他目录。',
     //2020-10-26-ljm新增
     filterHolder:'输入文件扩展名。如：MP4',
     countFiles:'计数文件',
     //2020-8-18-xth新增
    editShare: '编辑分享',
    toSource: '跳转到源文件',
    copyLink: '复制链接',
    toShare: '跳转到分享页',
    report: '举报',
    expand: '展开',
    shrink: '收起',
    //2020-12-2-ljm新增
    upgradeMulti:'升级线程',
    team: "团队",
    loadData:'正在加载数据，请稍候',
    getAccountInfo:'无法获取账号信息，请在重新登录后重试。',
    loadingData:'数据加载中...',
    failedEmptyTip: '无法加载失败文件。请联系<a href="mailto:support@multcloud.com">support@multcloud.com</a>，以获得进一步帮助。',
    runNow:'立即运行',
    emailFilter: '邮件过滤',
    me: "我",
    reset: "重置",
    apply: "应用",
    failureReason: '失败原因',
    countingFilesTip: '计算中({num}个文件)',
    taskName: '任务名称',
    frequency: '频率：',
    canceling: '正在取消…',
},
rightTopBanner: {
    navTransfer: '跨云盘传输',
    navInstagram: 'Instagram 下载器',
    navVideo: '视频下载器',
    navWeb: '网页图片下载器',
    traffic: '传输流量',
    upgrade: '升级会员',
    settings: '设置',
    changePassword: '修改密码',
    changeName: '修改用户名',
    bindEmail: '绑定邮箱',
    deleteAccount: '删除账号',
    language: '语言',
    help: '帮助',
    notifications: '通知',
    notification: '通知',
    subAccounts: '子账号',
    logout: '退出登录',
    tutorials: '教程',
    contact: '联系方式',
    limitsClouds: '云盘限制',
    faq: '常见问题',
    purTraffic: '购买流量',
    unlimitedPlan: '高级会员',
    monthlyUnlimitedPlan: '月无限订阅方案',
    rememberOriginal: '请记住您的初始用户名:',
    andPassword: '与密码',
    bindEmailOpen: '为了您的账号安全，您最好 <span style="color:#8a96e3;cursor:pointer;" id="bindEmailOpen">绑定您的电子邮箱并修改默认密码</span>。',
    lifeSwitchTip: '终身无限服务用户将终身享有无限传输流量。',
    lifeTimePlan: '终身无限版',
    browserPrompt:'为了您有更好的使用体验，我们建议您使用Google Chrome。',
    unlimited:'无限',
    lifeTimeNotice:'您当前为MultCloud终身无限方案用户。',
    subAccount:"子账号",
    bindMailTips:"请绑定您的邮箱，以便解锁云文件传输，充分利用 MultCloud。",
    bind:"绑定",
},
popup: {
    userStarPopup: {
        starDesc: "给 MultCloud 打个分吧",
        ok: "提交",
        thankYou: "谢谢你！",
        thankYouDesc: "如果您能抽出一点宝贵的时间来分享您使用 MultCloud 的真实体验，这将激励我们的团队把 MultCloud 做得更好。",
        reviewStart: "前往",
        reviewEnd: "给我们好评",
        feedbackTitle: "我们该如何改进？",
        feedbackDesc: "欢迎反馈您在使用 MultCloud 过程中遇到的问题，我们将予以重视。",
        feedbackBtn: "提交",
        feedbackYes: "感谢您的反馈。",
        feedbackNo: "请输入您的反馈意见。",
    },
    addCloudPopup: {
        endpointOptional:'端点（选填）',
        //2020.09.23 添加NAS云盘
        addNas: '添加 NAS',
        addNasFtpDes: `通过FTP连接NAS。不知道该如何为NAS设置FTP传输协议？ 请点 <a href="https://www.multcloud.com/help/enable-ftp-service-on-synology-nas.html" target="_blank" class='add-cloud-link'>这里</a>`,
        addNasWebDes: `通过WebDAV连接NAS。不知道如何为NAS设置WebDAV传输协议？ 请点 <a href="https://www.multcloud.com/help/enable-webdav-service-on-synology-nas.html" target="_blank" class='add-cloud-link'>这里</a>`,
        bucketName: '您的Bucket名称',
        accessKeyId: '访问密钥ID',
        secretAccessKey: '秘密访问密钥',
        idriveSecretAccessKey: 'Secret Access Key',
        idriveKeyId: 'Access Key ID',
        endpoint: 'Endpoint',
        displayName: '显示名称',
        addFtp: '添加FTP',
        addFtpDes: '为了添加您的FTP，MultCloud需要您输入身份验证信息。',
        egnyteTip: `提示：要获取您的 Key 和 Secret，您需要 Egnyte API 管理 ID。 如果没有，您可以<a href="https://developers.egnyte.com/member/register" target="_blank" class='add-cloud-link'>在这里注册</a>。`,
        icedriveTip: '注意：',
        icedriveTip1: '1. 仅支持添加Icedrive高级账户。',
        icedriveTip2:`2. 点击您的 Icedrive 用户名 -> 2FA 和访问 -> WebDAV -> 启用 -> 显示密钥。访问密钥即为密码。`,
        iCloudPhotosTip: '提示：',
        iCloudPhotosTip1: '1、在将 iCloud 照片连接到 MultCloud 之前，请确保 "在网页上访问 iCloud 数据 "已打开。',
        iCloudPhotosTip1Q: `如何管理对 iCloud 数据的网页访问<br><br>在iPhone或iPad上<br>1、打开“设置”APP。<br>2、点按你的姓名，然后点按“iCloud”。<br><br>3、轻点以打开或者关闭“在网页上访问 iCloud 数据”。<br>
        <br>在Mac上<br>1、选取苹果菜单 >“系统设置”。<br>2、点按你的姓名，然后点按“iCloud”。<br>3、轻点以打开或者关闭“在网页上访问 iCloud 数据”。`,
        iCloudPhotosTip2: '2、iCloud 照片仅支持以下图像格式： JFIF、PJPEG、JPEG、PJP、JPG、HEIC。',
        server: '服务器',
        protocol: '协议',
        port: '端口',
        passive: '被动模式',
        passphrase: '密码短语',
        explanation: '为了添加您的FTP，前缀应为 "ftp://" 或没有前缀。如果您的FTP端口不是默认值，而是其他端口号，如21，请用ftp://ftp.myhost.com:21这样的格式来指定端口。',
        userName: '用户名',
        passWord: '密码',
        advanced: '高级',
        commFTP: '常用FTP',
        transMode: '传输模式',
        encoding: '字符集编码',
        path: '路径（可选）',
        cloudName: '云盘名称',
        cloudService: '云盘服务',
        addedTime: '添加时间',
        userName: '用户名',
        usedSpace: '已用空间',
        totalSpace: '总空间',
        iCloudUsedSpace: 'iCloud Photos 已用空间',
        iCloudDriveUsedSpace: 'iCloud Drive 已用空间',
        iCloudTotalSpace: 'iCloud 总空间',
        iCloudDriveTotalSpace: 'iCloud 总空间',
        removeContent: '某些跨云盘任务是基于该云盘创建的，您确定要移除它？',
        google_driveTips: '从Google Drive传输文件到其他云盘时，请确保相同目录下没有相同文件名。',
        baiDuTips: '由于百度云盘的限制，文件/文件夹只能传输到“全部文件/我的应用数据/Multcloud”中。',
        mySQLQuestion: '默认端口为3306，当然您也可以自定义默认端口。',
        webDavQuestion: `如果您使用SSL链接，则应该在主机添加“https://”前缀或省略，此时端口应为443，否则，应添加前缀"http://"，其默认端口号为80。例如: https://dav.box.com/dav`,
        egnyteQuestion: '请登录Egnyte并且在地址栏找到您的域名。请按照这种格式输入您的域名：例：https://aomeitech.egnyte.com/',
        ownCloudQuestion: `如果您使用SSL链接,则应该在主机添加 "https: //" 前缀或省略，此时端口应为443，否则，应添加前缀"http://"，其默认端口号为80。例如: https://dav.box.com/dav`,
        amazonQuestion: `访问该页面以了解 <a href="https://www.multcloud.com/tutorials/s3-key.html" target="_blank" class='add-cloud-link'>如何获取Amazon S3 access key id</a>。`,
        boxTips: `Box不支持传输大于2GB的单个文件。`,
        google_drive_sharedWithMeTips:'当您传输文件到Shared With Me Drive的文件夹时，请确保你已被授权 "上传权限 "',
        gSuiteSharedDriveTips:'当您传输文件到Shared Drive的文件夹时，请确保您已被授权 "上传权限"',
        webDavTips: `1.在对文件执行操作前，请确认您对这些文件有读写权限。
            2. 请确认您有足够空间执行相关操作。我们目前无法获取您的空间大小。`,
        aDriveTips: '目前只支持个人付费帐号或企业帐号。',
        yandexTips: `1.请确认您有足够空间执行相关操作。我们目前无法获取您的空间大小。
                     2.如果您启用了应用密码，请在上面的密码栏中输入应用密码。`,
        googlePhotosTips: `1.“Photos”目录只能储存图片、视频以及其他多媒体文件，但不能存储文件夹。
            2.“Albums”目录只能存储文件夹，但不能存储文件。
            3.“Sharing”目录存储着所有您分享的影集或您加入的影集。
            4. Google Photos只支持上传图片、视频或其他多媒体文件。当您使用MultCloud执行上传操作时，您只能上传到由MultCloud创建或分享的影集。
            5. 当您在使用MultCloud源分享功能时，您只能分享由MultCloud创建的影集。
            6. 所有无标题的影集会被显示为“Untitled”。
            7. 当前支持文件下载，但是不支持下载原始文件。
            8. 目前不支持剪切、删除与重命名操作。你也无法使用与这些操作相关的功能。`,
        googlePhotosV2Tips: `1.“Photos”目录只能储存图片、视频以及其他多媒体文件，但不能存储文件夹。
            2.“Albums”目录只能存储文件夹，但不能存储文件。`,

        evernoteTips: `1. API限制 <a href='https://dev.evernote.com/doc/articles/rate_limits.php' target="_blank" class='add-cloud-link'> 查看详情>> </a>
              2. Evernote的限制是什么? <a href='https://help.evernote.com/hc/en-us/articles/209005247-What-are-the-system-limits-of-Evernote-' target="_blank" class='add-cloud-link'>查看详情>></a>
              3. 你只能上传小于50MB的文件到笔记
              4. 不能重命名或删除笔记内容文件（.ENML）。
              5. 只能复制笔记到笔记本，不能复制文件。`,

        flickrTips: `1. 只能传输图片或视频到Flickr。
            2. 文件夹只能传输到“Albums”目录下且文件夹下不能有子目录。
            3. 文件只能传输到“My Photostream”或者您在“Albums”下创建的子目录。
            4. 您所有的文件都可以在“My Photostream”中找到。
            5. “Albums”中所有文件都是引用“My Photostream”目录里的文件。`,

        mediafireTips: '不支持空文件夹的上传和下载。如果文件夹中有大量文件，可能需要花很长的时间来打开它。',

        mySQLTips: `1. 您的数据库需要能被我们的IP地址（209.126.%）访问。您可以使用以下命令来创建一个拥有足够权限的新用户：
            <span class='add-mysql-link'>GRANT SHOW DATABASES, SELECT, LOCK TABLES, RELOAD ON *.* TO username@'209.126.%' IDENTIFIED BY 'password'</span>;
            2. 您可能需要在您的服务器中把我们的IP地址段和访问端口号（默认端口号是3306）添加一条新的防火墙规则以便正常访问。`,
        hubiCTips: `1. 同一hubic账号不能多次添加。
            2. 不能重命名或者剪切文件和文件夹。
            3. 删除含有大量子文件的文件夹会比较缓慢。
            4. 不支持传输超过5GB的文件。
            5. 文件名不能超过248个字符，文件夹名称限制为256个字符。`,

        gSuiteUpTips: `只有G Suite管理员才能够添加G Suite到MultCloud。 在添加G Suite到MultCloud前，还需要为您的G Suite网域安装我们的 G Suite Marketplace app --- <a href='https://gsuite.google.com/marketplace/search/Cloud%20Transfer%20-%20MultCloud?hl=en' target="_blank" class='add-cloud-link'> "Cloud Transfer - MultCloud"</a> 。`,

        gSuiteTips: `1.您必须是<a href="https://support.google.com/a/answer/2405986?hl=en" target="_blank" class='add-cloud-link'> G Suite管理员</a>.
                        2.如何确定您是否是管理员? 首先，访问此链接 <a href='https://support.google.com/a/answer/2406043' target="_blank" class='add-cloud-link'> https://support.google.com/a/answer/2406043</a>。其次，在该链接登入您的G Suite账号。最后，您可以在“To create a custom role”下面看到结果。
                        3.确保 <a href='https://support.google.com/a/answer/60757?hl=en' target="_blank" class='add-cloud-link'>API Access </a> 是开启状态。
                        4.在添加G Suite之前，请先在您的网域安装我们的<a href='https://gsuite.google.com/marketplace?hl=en' target="_blank" class='add-cloud-link'> G Suite Marketplace app </a> "MultCloud for G Suite"，并确保 <a href='https://admin.google.com/' target="_blank" class='add-cloud-link'> 设置 </a>无误：状态与数据访问权限为开启状态。 `,
        hiDriveTips: `1.在处理文件前，请确保您的账户已启用 WebDAV 协议并具有读/写权限，否则 MultCloud 可能无法将文件传输到您的HiDrive。`,
        backblazeTips: `
        1. 每个bucket name的名称不能小于6个字符。
        2. 每当您生成了一个新的验证密码， 之前的验证密码就会失效。
        3. 文件名称不能以 "/"
        作为开头或结尾， 也不能含有 "//"。 `,
        WEBDETips: `1. 请确保您有文件的读 / 写权限， 否则MultCloud将无法传输WEB.DE的文件。
        2. '请确认您有足够空间执行相关操作。我们目前无法获取您的空间大小。`,
        alfrescoTips: `Alfresco免费账号的网络存储空间为10GB且单个文件大小不能超过50MB。`,
        cloudMeTips: `1.请确保您有文件的读/写权限，否则MultCloud将无法传输CloudMe的文件。
            2. 请确认您有足够空间执行相关操作。我们目前无法获取您的空间大小。`,
        myDriveTips: `请确认您有足够空间执行相关操作。我们目前无法获取您的空间大小。`,
        cubbyTips: `1.请确保您有文件的读/写权限，否则MultCloud将无法传输cubby的文件。
            2. 请确认您有足够空间执行相关操作。我们目前无法获取您的空间大小。`,
        cloudType: '云盘类型',
        notificationTip: `感谢使用最新版的MultCloud，如果您有任何问题，请发送邮件到：<a href="mailto:support@multcloud.com">support@multcloud.com</a>，谢谢。`,
        notAbleAccess: '无法访问Google Photos问题修复',
        problemNotAccess: '无法访问Google Photos问题已修复。如果您仍然无法访问Google Photos，请重新添加。',
        noPrompt: '下次不再提醒',
        addFeatures: '新增功能如下：',
        version: '版本：',
        applicationKey: '验证密码',
        keyID: 'keyID',
        privateKey: '验证文件 (可选)',
        FTPTips:`1.您需要拥有对FTP的目录与文件的读写权限，否则可能无法操作它们。
        2.由于不能识别FTP的空间大小，请确保它有足够多的空间。
        3.如果不能正常访问ftp,请把209.126.103.1/19和207.38.89.1/24加入到防火墙白名单中。`,
        specialDropBox:`如果您是Dropbox企业版管理员，并希望访问您组织的所有账户，请点击 "访问团队账户"。`,
        specialDropBoxBottom:`如果您想访问您的个人云盘，请点击 "访问个人云盘"。`,
        accessOrganization:'访问团队账户',
        accessPersonalCloud:'访问个人云盘',
        specialBoxBusiness:'如果您是box for Business的管理员，并希望访问您组织的所有账户，请点击 "访问团队账户"。',
        specialgSuite:`如果您是 <a href='https://support.google.com/a/answer/2405986?hl=zh-Hans' target="_blank" class='add-cloud-link'> Google Workspace 管理员 </a> 并希望访问您组织的所有账户， 请先通过域名安装我们的 G Suite Marketplace 应用程序 --- "<a href="https://gsuite.google.com/marketplace/app/cloud_transfer_multcloud/72136911391?hl=zh-Hans" target="_blank" class='add-cloud-link'>Cloud Transfer – MultCloud</a>". 然后点击 "访问团队账户"。`,
        specialOnedrive:`如果您是OneDrive for Business的管理员，并且想访问您组织的所有账户，请点击 "访问团队账户"。`,
        iCloudPhotosTips:'MultCloud暂不支持没有邮箱的Apple ID登录。',
        appleId: 'Apple ID',
        addICloudPhotos: '添加 iCloud 照片',
        addICloudDrive: '添加 iCloud Drive',
        fourShared: `注意：4shared授权有效期为<span style="color: red">2小时。</span>授权到期后，请重新添加4shared并手动执行您的任务。`,
        fourSharedTips:'注意：4shared授权有效期为2小时。授权到期后，请重新添加4shared并手动执行您的任务。'
        },
    cloudExploerPopup: {
        googlePhotosV2Tips: '谷歌Photos 使用提示',
        googlePhotosV2TipsDesc: '截至2025年5月7日，谷歌已更新谷歌Photos API。为适应这些变更，我们需要进行以下调整：',
        googlePhotosV2Tips1: '"相册"文件夹将仅显示由MultCloud创建的相册。',
        googlePhotosV2Tips2: '"照片"文件夹将仅显示通过MultCloud上传的图片。',
        googlePhotosV2Tips3: '若需将图片从谷歌Photos传输至其他云盘，请点击"添加更多照片"按钮，并授权MultCloud访问待传输的图片。',
        googlePhotosV2Tips4: '将其他云盘的图片传输至谷歌Photos时请注意：仅支持将整个文件夹传输至"相册"文件夹，单个图片仅能传输至"照片"文件夹。',
        googlePhotosV2TipsShow: '不再显示此提示',
        googlePhotosV2AddMore: '添加更多照片',
        googlePhotosV2AddMoreTips: '点击此处添加您希望上传至MultCloud的图片。',
        googlePhotosV2FolderName: '文件夹名称',
        googlePhotosV2FolderNameInput: '命名存放图片的文件夹',
        googlePhotosV2NotSelect: '您尚未添加任何照片。点击"添加更多照片"将图片上传至MultCloud',
        googlePhotosV2SelectAlbums: '仅支持将文件夹保存至"相册"',
        googlePhotosV2SelectAlbum: '此文件夹仅支持保存图片和视频',
        googlePhotosV2SelectPhotos: '"照片"文件夹仅支持保存图片和视频',
        googlePhotosV2SelectSession: '该文件夹不可选为目标路径，请选择"相册"或"照片"文件夹。',
        deleteContentEver: '您确定要永久删除所选项目吗？<br>一旦删除，就无法从已删除邮件中恢复。',
        deleteContent: '您确定要删除所选项目吗？',
        detailedProgress: '详细进度',
        highSpeed: '以下云盘支持快速搜索功能',
        takeMoreTime: '搜索以下云盘的文件会花更长时间',
        enterKeyWord: '输入关键字',
        highSpeedSearch: '快速搜索',
        normalSearch: '普通搜索',
        shareWithOthers: '分享给他人',
        inviteByEmail: '通过邮件邀请',
        pleaseEnterEmail: '请输入电子邮件，并用逗号隔开',
        addMessage: '添加消息(可选)',
        shareTo: '分享到',
        noLink: '尚未创建链接',
        createShare: '创建分享',
        cancelAllTask: '您确定要取消所有任务吗?',
        //2020/8/7-xth
        shareEmailTitle: '通过邮件发送分享链接',
        shareNotSupportSource: '该云盘不支持该分享功能，请更换分享选项',
        shareSendEmail: '发送邮件',
        generateLinkSuccess: '创建分享链接成功',
        generateLinkFail: '创建分享链接失败',
        emailSentSuccessful: '发送邮件成功',
        emailSentNull: '您还没有输入邮箱',
        emailSentNotice: '请输入正确的邮箱地址',
        linkCopySuccessful: '复制链接成功',
        sharePrivateLink: '私人分享链接：',
        sharePrivatePassword: ' 查看密码：',
        cancelMyShareTask: '您确定要取消该分享吗？取消后该分享将无法访问',
        cancelMyShareOk: '是的，取消',
        cancelMyShareNot: '不，保留',
        emailArrayToLong50: '您一次可以发送50封邮件',
        shareOnEmail: '通过电子邮件发送链接',
        shareOnFacebook: '分享到Facebook',
        shareOnTwitter: '分享到Twitter',
        shareOnTumblr: '分享到Tumblr',
        shareOnPinterest: '分享到Pinterest',
        shareOnLinkedIn: '分享到LinkedIn',
        ceateShareError: '分享失败，请检查您的网络。'

    },
    cloudTransferPopup: {
        pleaSelect: '请选择',
        schedule: '定时',
        checkScheduled: '请选中此任务的“定时执行”框激活计划后才能编辑.',
        checkScheduled: '请勾选 \'定时任务\' 选框以激活定时功能。',
        addValidCloud: '你必须添加一个有效的云盘',
        //2020-10-26-ljm增加
        cleanList:'清空'
    },
    personalCenter: {
        changePassword: '修改密码',
        changeName: '修改用户名',
        deleteAccount: '删除账号',
        enterPassWord: '请输入您的密码',
        note: '注意：请告诉我们您离开的原因，我们将尽力进行优化。',
        sureDeleteAccount: '您确定想删除这个账号吗？',
        unsubscribe: '删除此账号之前，请先取消订阅MultCloud。',
        bindEmail: '绑定邮件',
        pleaseSwitch: '请切换到MultCloud经典界面以解锁文件。',
        switchOld: '切换至经典界面',
        pleaseUnsubscribe: '请先切换至MultCloud经典界面，取消订阅服务。',
        deletePremium: '请问您确定要删除这个付费账号吗？一旦您删除了该账号，将无法找回。'
    },
    remoteTaskPopup: {
        addLinkTask: '添加链接任务',
        validLink: '请输入有效的链接',
        saveCloud: '保存至云盘',
        parseFail:'解析失败',
        inadmissibleRequest:'不支持该请求',
        createBtTask: '创建种子任务',
        savingPrivateRyun: 'Saving Private Ryun',
        emptySource: '请输入链接或者选择种子文件',
        validTorrent: '选择的种子文件无效',
        addTorrent: '选择种子',
        tip: '请选择用户储存的云盘',
        emptySource: '请输入一个链接或上传一个种子文件',
        validTorrent: '无效种子文件',
        addTorrent: '添加种子',
        tip: '请选择一个云盘以保存该文件',
        torrentSelected:'名称（{num}/{all}）',
        urlLinkSupported:'请把链接复制粘贴到这里，支持http/https/magnet链接,\n注意：请不要使用MultCloud下载或上传侵权内容',
        torrentStore:'请选择您想要保存种子文件的云盘',
        downloadLink:'请输入下载链接',
        cancelTask:'取消任务',
        cancelTaskContent:'您确定要取消任务吗？',
        parseTaskRunning:'MultCloud已经存在一个解析任务了，请到"离线上传"中查看'
    },
    taskListPopup: {
        deleteTask: '删除任务',
        pleaseSelect: '请先选择任务，再删除。',
        sureDeleteTask: '您确定要删除这些任务吗?',
        deleteSingleTask: '您确定要删除此任务吗?',
        viewLogs: '查看日志',
        selectCloud: '请选择用户存储文件的云盘'
    },
    upgradeAccountPopup: {
        commonTitle: '同时运行5个跨云任务',
        commonDes: '请升级为订阅用户，您将能并行5个跨云任务。',
        upgradeAccount: '升级账号',
        upgradeHeadTitle:'同时执行5个URL或种子任务',
        upgradeHeadContent:"免费用户可以同时执行1个链接或种子任务。升级成为订阅用户可以同时执行5个链接或种子任务",
        currentPlan: '当前方案',
        insufficientTraffic: '跨云盘传输流量不足',
        insufficientTrafficDes: '本月免费流量已用尽。请升级至付费版以获取更多流量。',
        filter: '文件传输/同步过滤',
        filterDes: '请升级到付费版以获得文件传输/同步过滤功能。.',
        modes: '高级同步模式',
        offlineFree: '同时执行1个链接或种子任务',
        offlinePremium: '同时执行5个链接或种子任务',
        modesDes: '订阅用户可使用双向同步与其他7种单向同步模式。支持：增量备份同步。',
        doubleRealTime:'同时执行两个实时同步任务',
        doubleRealTimeSyncDes:'若想同时执行两个实时同步任务，请先升级为订阅账号。',
        doubledSync: '同时执行两个普通同步任务',
        doubleSyncDes: '若想同时执行两个普通任务，请先升级为订阅账号。',
        realTimeSyncing:'同时执行两个实时同步任务',
        norMalSyncing:'同时执行两个普通同步任务',
        free: '免费版',
        premium: '付费版',
        monthTraffic: '5GB 流量/每月',
        syncMode: '两种同步模式',
        scheduled: '计划传输/同步/备份',
        scheduledDes: '如果要激活计划任务功能，请升级到高级版本。',
        moreTraffic: '您需要的额外流量',
        moreSyncModes: '8种同步模式',
        transferSpeed: '五倍传输速度',
        doubleSync: '同时执行两个同步任务',
        transferServer: 'VIP传输服务器',
        customerSupport: 'VIP客服通道',
        syncSupported: '双向同步以及7种单向同步方式，支持增量备份同步。',
        greatlyIncreased: '订阅用户有10个线程进行文件传输，而免费用户只有两个，这样传输速度会获得更大提升。',
        sameTime: '订阅者可以使2个实时同步和2个普通同步任务（共4个任务）同时执行。',
        normalSametime:'订阅用户可同时执行两个普通同步任务',
        automatically: '通过设置文件名或后缀，自动传输符合规范的文件',
        multipleSync: '多目标同步',
        multipleSyncDes: '请升级成为订阅用户来解锁“多目标同步”功能。',
        freeDes:'免费用户每月有30GB的流量用于跨云盘文件传输/同步。',
        task1: '同时运行1个跨云任务',
        task5: '同时运行5个跨云任务',
        emailTitle: '邮件转换额度不足',
        emailDes: '免费用户每月可转换50封邮件，但您需要的似乎不止于此。升级至高级版，畅享无限邮件转换。',
        emailsConversions: '50封邮件转换/月',
        emailsUn: '无限邮件转换',
    },
    remindBindEmail:{
        bindExe:'请在绑定您的邮箱后，在执行该任务',
        onceBind:'您在绑定邮箱后可获得<span class="gift-flow">30GB</span>额外的跨云盘传输流量！',
        bindEmail:'请绑定您的电子邮箱以激活多云的核心功能。',
        coreFeatures:'Multcloud核心功能',
        tourAccount:'游客账号',
        connectCloud:'连接云盘到MultCloud',
        viewCloud:'使用MultCloud查看所有云盘文件',
        uploadFile:'使用MultCloud上传文件到云盘',
        downloadCloud:'使用MultCloud下载云盘文件',
        syncAndBackup:'云盘间备份与同步文件',
        transferFiles:'把文件从一个云盘传输到另一个云盘',
        failed:'执行该操作失败，请稍后再试。'
    },
    salePagePopup:{
        sOffer:'“月无限”特别推荐',
        timeLimited:'时间有限, 赶快行动!',
        Hours:'时',
        Minutes:'分',
        Seconds:'秒',
        monthPrice:'$19.9/月',
        dataTra:'即可获得无限流量',
        subscribe:'立即订阅',
        features:'主要功能',
        freePlan:'免费方案',
        bigSale:'限时折扣',
        discountsto:'折扣低至',
        off:'75折',
        premiumPlan:'付费方案',
        transmit:'传输数据流量',
        dataTraffic:'从一个云盘传输或同步文件到另一个云盘的数据流量',
        originalPrice:'原价',
        nowOnly:'现价',
        getDiscount:'立即购买',
        moreData:'更多传送流量',
        unlimitedData:'无限流量',
        syncModes:'更多跨云盘同步方式',
        syncModesDes:'订阅用户可以使用双向同步以及7种单向同步方式，支持镜像同步。',
        scheduledTran:'定时传输',
        scheduledTranDes:'该功能允许您在一个固定的时间间隔或在一个特定的时间完成自动的跨云传输任务',
        transferSpeedDes:'订阅用户会获得10个传输线程（免费用户2个）进行跨云盘文件传输，传输速度也因此会获得极大提升。',
        fileEncryption:'文件加密',
        encryptFiles:'订阅用户可以在线加密云盘中的文件和上传的文件。',
        quarterly:'每季',
        yearly:'每年',
        monthGb:'150GB/每月',
        monthGbly:'200GB/每月',
        monthfourLy:'400GB/每月',
        unTr:'不限流量',
        nMonth:'/月',
        tQuarter:'/季',
        eYear:'/年',
        tOneTime:'一次性',
         //2021-10-09
         premiumFeatures:'可一个月内使用150GB的流量以及所有的高级功能！',
         unlimitedYear:'可一年内使用不限量流量及所有高级功能！',
         unlimitedLiftime:'可终生使用不限量流量及所有高级功能！',
    },
    properties: '属性',
    general: '一般',
    tips: '提示',
    progress: '进程',
    limits: '云盘限制',
    detailed: '详情',
    cancel: '全部取消',
    simpleSync: '简单同步',
    onewaySync: '单向同步',
    twowaySync: '双向同步',
    advancedSync: '高级同步模式',
    mirrorSync: '镜像同步',
    moveSync: '移动同步',
    cmuSync: '累加同步',
    updateSync: '更新同步',
    increSync: '增量同步',
    fullSync: '完全备份同步',
    simpleSyncTip: '在源目录中添加，修改和删除会被反映到目标目录中，但在目标目录中的添加，修改和删除不会影响源目录。',
    mirrorSyncTip: '终始保持目标目录中的文件和源目录完全一致（MultCloud 会删除目标目录中多余的文件）。',
    moveSyncTip: '在完成同步后，删除源目录中的所有文件。',
    cmuSyncTip: '当源目录中的文件删除时，不删除目标目录中对应的文件。',
    updateSyncTip: '先删除目标目录中所有文件，然后将源目录中新增和修改的文件传输到目标目录。',
    increSyncTip: '在每次同步时，都会在目标目录中新建一个子目录，以便将源目录中新增和修改的文件传输到这个子目录中。',
    fullSyncTip: '在每次同步时，会在目标目录中新建一个子目录，以便将源目录中所有文件传输到这个子目录中。',
    twowaySyncTip: '在源目录中添加，修改和删除会被反映到目标目录中，同时在目标目录中的添加，修改和删除也会反映到源目录（也即是终始保持源目录和目标目录中的文件完全一致）。',
    syncModes: '同步模式',
    email: '邮件',
    filter: '过滤',
    thread: '线程',
    once: '一次',
    daily: '每天',
    weekly: '每周',
    monthly: '每月',
    onlyOnce: '仅在这个时间点运行:',
    everyDay: '每天的这个时间点:',
    everyWeek: '每周的星期:',
    at: '时间:',
    sunday: '日',
    monday: '一',
    tuesday: '二',
    wednesday: '三',
    thursday: '四',
    friday: '五',
    saturday: '六',
    runAt: '时间:',
    lastDay: '最后一天',
    chooseAction: '如果目标位置存在这个文件则:',
    optionsPrompt: '假如源云盘中有目标云盘不支持的特殊文件名，这些文件在传输时会被自动更名，在目标根目录生成log.html文件，当您传回源文件将还原文件名。',
    sourceNewer: '如果源文件较新则覆盖文件。',
    diffSize: '如果文件大小不同则覆盖文件。',
    sourceAll: '如果源文件较新或大小不同则覆盖文件。',
    skipFile: '直接跳过该文件，不传输。',
    skipEmail: '直接跳过该邮件，不传输。',
    overWrite: '总是覆盖该文件。',
    rename: '重命名',
    overWriteSourceNewer: '若原邮件存在更新，则覆盖。',
    deleteAllSource: '完成传输后删除所有源文件。',
    keepFileDate: `保留文件修改日期 (支持Dropbox,、Google Drive、G Suite)。`,
    automaRename: '自动将特殊字符的文件更名并生成脚本文件。',
    sendEmail: '任务结束时发送邮件通知。',
    sendMessage: '发送测试邮件',
    ignoreFiles: '排除这些文件',
    includeFiles: '包含这些文件',
    selectSync: '您可以在此选择同步模式:',
    tipsFor: '提示',
    allTasks: '所有任务',
    successful: '成功',
    unfinished: '未完成',
    transferDetails: '传输详情',
    redit: '再次编辑',
    publicShare: '公开分享',
    publicTip: '说明:任何有该链接的用户都可以查看该文件。',
    privateShare: '私密分享',
    privateTip: '说明:只有拥有查看密码的用户才能查看私密分享链接，分享时需要将链接和密码一起分享。',
    sourceShare: '源分享',
    sourceTip: '说明:云盘源分享链接是云盘自带的分享功能，但仅有少数云盘支持该功能。',
    shareSuccess: '成功创建分享',
    copySuccess: '复制成功',
    sharedYet: "该文件已被分享",
    domain: '域名',
    key: 'Key',
    secret: 'Secret',
    //2020-10-26-ljm增加
    progressBox:'进度框',
    //xth
    publicShareEasy: '任何人',
    privateShareEasy: '私人',
    communityShareEasy: '公共',
    sourceShareEasy: '源',
    reportPopup: {
        title: '举报分享',
        beforeMsgOne: '帮助我们了解这个分享的问题。',
        beforeMsgTwo: '您会如何描述？',
        typeItems: {
            spam: '垃圾邮件',
            malwareVirus: '恶意软件',
            copyrightViolation: '侵权内容',
            illegal: '违法内容',
            notWorking: 'MultCloud没有正常工作',
            other: '其他不合适的内容',
        },
        nextMsgOne: '请填写举报信息。',
        description: '描述',
        nextMsgTwo: '请描述该分享的问题。',
        yourEmail: '您的邮箱',
        nextMsgThree: '请提供您的联系邮箱以便我们联系您',
        submit: '提交',
        back: '返回',
        next: '下一步',
        messageNone: '请输入该举报的描述。',
        emailNone: '请输入您的联系邮箱。',
        success: '举报已成功发送。'
    },
    subAccountPopup:{
        title: "子账号管理",
        titleMax: "子账号管理",
        titleDes:"升级成为付费用户，即可解锁子账号相关功能。",
        tabNameUser: "用户模式",
        tabNameItem: "文件夹模式",
        addItemButton: "分配文件夹",
        users: "用户",
        folders: "文件夹",
        read: "读",
        write: "写",
        questionTxtRead: "子账号用户可以下载，预览此文件夹中的文件，并将其复制到自己的云盘空间中。",
        questionTxtWrite: "子账号用户可以创建新文件夹，上传、删除和重命名此文件夹中的文件。",
        userExist:"该用户已存在。",
        userSelf:"请勿添加自己的账号。",
        quickAssign: "快捷分配",
        quickAdd: "快捷添加",
        allow: "允许",
        batchAddUserNull: "目前未添加用户。",
        batchAddItemNull: "目前未添加文件夹。",
        noUserFromAddItem: "请先添加一个用户。",
        noItemFromAddUser: "请先添加一个文件夹。",
        addUser: {
            title: "添加用户",
            radioCreate: "创建一个子账号",
            radioAdd: "添加一个现有的MultCloud账号",
            createNamePlaceholder: "创建用户名",
            createPasswordPlaceholder: "创建密码",
            addNamePlaceholder: "请输入现有的MultCloud账号",
            createNameNone: "请填入一个用户名。",
            createNameMore: "用户名应少于20个字符。",
            createPasswordNone: "请输入密码。",
            createPasswordError: "请输入8-16个字符的密码。",
            addUserNameNone: "请输入一个现有的MultCloud账号。",
            addUserNone: "此账号不存在。",
        },
        addItem: {
            noFolder: "请选中一个文件夹。",
            exist: "您已经添加了该文件夹。",
        },
        editUser: {
            title: "编辑子账号",
            namePlaceholder: "输入用户名",
        },
        cancel: {
            titleUser: "删除子账号",
            titleItem: "移除文件夹",
            msgUser: "您确定要删除此账号吗？",
            msgItem: "您确定要移除此文件夹吗？",
        },
        unknownError: "找不到路径，请检查路径是否存在或重新添加云盘。",
    },
    verifyPopup: {
        verifyTitle: "验证您的身份",
        toRecoveryText: "我无法进行验证",
        verifyEmailTitle: "验证您的邮箱",
        verifyEmailTips: "我们会向 {email}发送验证码. 为了验证您的电子邮箱地址，请在下方输入。",
        verifyPhoneTitle: "验证你的手机号",
        verifyPhoneTips: "我们会发送一个验证码到{phone}. 为了验证这是您的手机，请输入以{last}结尾的后四位手机尾号。",
        verifyPhoneText: "手机号后四位",
        sendCodeBtn: "发送验证码",
        enterCode: "输入验证码",
        checkEmailTips: "如果{email} 是您的验证邮箱, 我们会向其发送一个验证码。",
        checkPhoneTips: "如果{phone}符合你的后四位手机尾号，我们会向其发送一个验证码。",
        askDevice: "信任该设备。",
        verify: "验证",
        recoveryTitile: "您是否有恢复密码？",
        recoveryTipsOne: "如果您有恢复密码，请立即输入。如果您没有，请联系",
        recoveryTipsTwo: "您的恢复密码的长度为25位，密码形式：XXXXX-XXXXX-XXXXX-XXXXX-XXXXX。",
        recoveryCode: "恢复密码",
        recoveryCodeBtn: "使用恢复密码",
        recoveryChangeTitile: "我们还能怎样验证您的身份？",
        recoveryEmailChange: "添加验证邮箱地址",
        recoveryPhoneChange: "添加验证手机",
        enterEmail: "输入您的邮箱",
        recoveryNextTitle: "请输入我们发到 {checkCode}的验证码",
        recoveryTipsTitle: "为了确保您的账号安全，更新验证信息需要30天的时间！",
        recoveryTips1: "因为您开启了双重验证，您要用最新的验证信息来登录您的账号。",
        recoveryTips2: "在等待期间，您将无法通过您的账号登录，但可以通过信任设备登录。",
        recoveryTips3: "您可以通过如下方式避免等待：",
        recoveryTips4: "使用信任的设备。",
        recoveryTips5: "如果您有一台不需要输入验证码的设备，请立即在该设备上更新您的安全验证信息。",
        recoveryTips6: "找到您的安全验证信息。",
        recoveryTips7: "还有什么机会找回来吗？如果您能成功找回，现在就使用它他重新登入您的账号。",
        recoveryTips8: "这个等待会让窃取您密码的人难以获取您的账号。",
        recoveryPendTitle: "您的安全验证信息更新操作处于等待执行状态。",
        recoveryPendTips1: "您在 {data}申请更改您的安全验证信息。",
        recoveryPendTips2: "当前的安全验证信息",
        recoveryPendTips3: "验证邮箱：",
        recoveryPendTips4: "验证手机号：",
        recoveryPendTips5: "新的安全验证信息",
        recoveryPendTips6: "如果您想要保留当前的安全验证信息，",
        recoveryPendTips7: "取消该申请。",
        recoveryCancelTitle: "这是您新的恢复密码",
        recoveryCancelTips1: "为了您的账号安全，您需要一个新的恢复密码。",
        recoveryCancelTips2: "如果您需要找回您的账号，这个恢复密码能够帮到您。您需要把这个恢复密码存储在一个安全的地方，我们强烈的建议您不要把该密码存储在网络设备上。",
        recoveryCancelTips3: "您之前的一个恢复密码将失效。请使用新的恢复密码。",
        recoveryCancelTips4: "您的新密码是：",
        recoveryCancelSucTitle: "好的！我们已找回账号！",
        recoveryCancelSucTips1: "为 {old}更改安全验证信息的申请已经取消，您现在已获得该账号的所有访问权限。",
        recoveryCancelSucTips2: "以({new})作为您的安全验证信息的申请已经取消，并且不会生效。",
        recoveryCancelSucTips3: "点击 \"下一步\" 返回之前的界面。",
        recoveryCancelErrorTitle: "提交申请",
        recoveryCancelErrorTips: "您的账号仍处在等待阶段。",
        codeText: "请输入您的手机号",
        exception: {
            emailTwoStringError: "正确的邮箱以 \"{errorCode}\"作为开头。",
            validEmail: "请输入一个正确的邮箱。",
            phoneLastTwoStringError: "正确的手机号以 {errorCode}为结尾。",
            validPhone: "你需要输入手机号的后4位数字。",
            verificationCodeExpired: "验证码已过期。",
            verificationCodeError: "该验证码不正确，请检查验证码后重试。",
            verificationRecoveryCodeExpired: "该验证码无效，请检查验证码后重试。",
            verificationCodeNull: "请输入验证码。",
        }
    },
    worldBackupPopup: {
        // title:'世界备份日',
        title:'MultCloud特别优惠',
        titleTip:'24小时闪购',
        timerTitle:'该优惠活动有时间限制，将要结束...',
        getOffer:'获取优惠',
        tips100Mo:'100GB/月 数据流量',
        ps100Mo:'提示：未使用的数据流量会累积起来。例如，您在第一年只使用了100GB中的50GB数据流量，在下个月您仍然有50GB的额外数据流量。',
        tips1200Yr:'1200GB/年 数据流量',
        ps1200Yr:'提示：未使用的数据流量会累积起来。例如，您在第一个月只使用了1200GB中的1000GB数据流量，在下一年您仍然有200GB的额外数据流量。',
        tips2400Yr:'2400GB/年 数据流量',
        ps2400Yr:'提示：未使用的数据流量会累积起来。例如，您在第一个月只使用了2400GB中的2000GB数据流量，在下一年您仍然有400GB的额外数据流量。',
        tipsUnYr:'无限/年 数据流量',
        psUnYr:'提示：一年内无限制的数据流量!',
        tipsUnLi:'无限/终身 数据流量',
        psUnLi:'提示：终身无限数据流量!',
        tips1:'10个传输文件的线程',
        tips2:'计划的云传输',
        tips3:'24/7/365 优先服务',
        ps1:'订阅者可使用10个线程，而免费用户只可使用2个线程，所以传输速度能大大增加。',
        ps2:'订阅者可以计划定期或特定时间的自动云到云传输/同步。',
        moPrice:'{price}/月',
    },
    iosPayTipPopup: {
        title: '取消苹果订阅',
        tip: '您当前的{name}处于自动续订状态（苹果交易ID：{id}），请取消订阅并重新尝试。',
        btnTxt: '如何取消',
    },
    appRecommendPopup: {
        title: 'MultCloud移动端应用程序上线！',
        tip: '立刻下载移动应用程序，管理并传输您的云端文件。',
        modileTitle: '现在就下载MultCloud移动程序！',
        iosBtnTitle: '下载',
        iosBtnTip: 'App Store',
        androidBtnTitle: '下载应用，请到',
        androidBtnTip: 'Google Play',
        apkBtnTitle: '下载',
        apkBtnTip: 'MultCloud',
    },
    note: '提示',
    editCloudNoticPopup: {
        tips: '当前云盘已失效，请重新添加后重试。',
        btnTxt: '重新添加',
    },
    appleTipsPopup: {
        title: '提示',
        tipTitle: '关于 iCloud 照片双重身份验证的提示',
        tip1: '要将您的 iCloud 照片连接到 MultCloud，您需要授权 MultCloud 服务器访问您的 Apple ID。因此，在双重身份验证的过程中，您可能会看到我们的服务器位置与您的实际位置不同。',
        tip2: '您的安全和隐私是我们的第一要务。MultCloud 可能会根据您的操作暂时缓存部分内容，但不会永久存储您的数据，一旦操作完成，这些数据将立即从我们的服务器中删除。您的 iCloud 照片和 MultCloud 服务器之间的连接始终通过安全的256位SSL协议完成。',
        checkTip: '不再提示',
    },
    iCloudDriveTips: {
        title: '提示',
        tipTitle: '关于 iCloud Drive双重身份验证的提示',
        tip1: '要将您的 iCloud 云盘连接到 MultCloud，您需要授权 MultCloud 服务器访问您的 Apple ID。因此，在双重身份验证的过程中，您可能会看到我们的服务器位置与您的实际位置不同。',
        tip2: '您的安全和隐私是我们的第一要务。MultCloud 可能会根据您的操作暂时缓存部分内容，但不会永久存储您的数据，一旦操作完成，这些数据将立即从我们的服务器中删除。您的 iCloud 云盘和 MultCloud 服务器之间的连接始终通过安全的256位SSL协议完成。',
        checkTip: '不再提示',
    },
    checkApplePopup: {
        title: '双重验证',
        tip1: '您已开启双重验证，请在您的 iPhone/iPad/iPod 上输入验证码以继续。',
        tip2: '没有收到验证码吗？',
        btn1: '消息发送中...',
        btn2: '重发验证码',
        btn3: '发短信给我',
        btn4: '获得支持',
        suc1: '一条带有验证码的信息已被发送到{num}。',
        suc2: '一条带有验证码的信息已发送到您的设备上。',
        fail1: '发送验证码失败，请重试。',
        fail2: '请输入验证码以继续。',
    },
    downloadThreadPopup: {
        title: "下载设置",
        tips: "下载文件的名称",
        defaultNameOne: "Emails saved on {date}",
        defaultName: "{num} emails saved on {date}",
        option1: "保存附件",
        option2: "会话格式",
        option2Tips: "勾选时邮件引用的内容将会被移除。",
        option3: "仅保存最后一条消息",
    },
    failedFilesPopup: {
        title: '查看失败文件：{num} 个',
        exportExcel: '导出为Excel表格',
        retrySucTip: '{num} 项 已添加至重试列表.',
    },
    viewLogsPopup: {
        title: '任务详情：',
        titleRe: '还原详情：',
        errorNum: '失败个数',
        addNum: '增加文件',
        updateNum: '修改文件',
        deleteNum: '删除文件',
        syncSize: '同步大小',
        syncTime: '同步耗时',
        backupNum: '备份数量',
        backupSize: '备份大小',
        backupTime: '备份耗时',
        tranNum: '传输数量',
        tranSize: '传输大小',
        tranTime: '传输耗时',
        from: '来源：',
        to: '目标：',
        executeTime: '执行时间：',
        sourceAccount:'来源账户',
        targetAccounts:'目标账户',
        executeResult: '执行结果',
        add: '增加：',
        update: '更新：',
        delete: '删除：',
    },
    taskProgressPopup: {
        title1: '您是付费用户，可以同时使用10个线程来传输数据。',
        title2: '订阅任何计划，享受多至10个线程！',
        btnTip: '低至$9.99起',
    },
    subfileSelectPopup: {
        title: '选择上传内容',
    },
    deleteBatchPopup: {
        tips1: '确定要删除这 <span>{num}</span> 个任务吗？',
        tips2: '任务删除后将不可恢复',
    },
    freeSaledPopup: {
        tips1: '立即提升你的云生产力！免费领取额外10GB云传输流量（无限制）',
        tips2: '请稍候！',
        tips3: '你要放弃奖励吗？一旦放弃，奖励就没了！',
        btns1: '领取10GB流量',
        btns2: '不领取',
        success: '恭喜！你获得了10GB云传输流量。',
    }
},
addCloud: {
    connectDesc: '选择您想要添加到MultCloud的云盘',
    box: 'Box',
    boxBusiness:'box for Business',
    dropbox: 'Dropbox',
    google_drive: '谷歌云盘',
    google_drive_sharedWithMe: '谷歌分享',
    google_drive_v2: '谷歌云盘',
    google_drive_shared_v2: '谷歌分享',
    oneDrive: '微软云盘',
    oneDriveV2: '微软云盘',
    sugarSync: 'SugarSync',
    amazonS3: '亚马逊S3',
    iDrivee2: 'IDrive® e2',
    webDav: 'WebDav',
    FTP: 'FTP',
    cloudMe: 'CloudMe',
    cubby: 'Cubby',
    myDrive: 'MyDrive',
    yandex: 'Yandex',
    hiDrive: 'HiDrive',
    WEBDE: 'WEB.DE',
    baiDu: '百度网盘',
    amazon: 'Amazon',
    alfresco: 'Alfresco',
    aDrive: 'ADrive',
    Icedrive: 'Icedrive',
    NAS: 'NAS',
    oneDrive4Business: '微软企业云盘',
    dropbox4Business: 'Dropbox Business',
    pCloud: 'pCloud',
    mega: 'Mega',
    backblaze: 'Backblaze',
    putio: 'Putio',
    googlePhotos: '谷歌Photos',
    googlePhotosV2: '谷歌Photos',
    evernote: 'Evernote',
    flickr: 'Flickr',
    mediafire: 'Mediafire',
    ownCloud: 'OwnCloud',
    mySQL: 'MySQL',
    gSuite: 'Google Workspace',
    gSuiteSharedDrive: 'Shared Drive',
    hubiC: 'HubiC',
    egnyte: 'Egnyte',
    youtube1: 'youtube1',
    facebook: '脸谱网',
    picasa: 'picasa',
    goDaddy: 'goDaddy',
    ubuntu: 'ubuntu',
    welcomeTo: '欢迎来到MultCloud',
    welcomeFont: '您可以使用MultCloud轻松管理多个云盘，并且在不同云盘间传输文件。现在就把您的云盘添加到MultCloud吧。',
    peCloud:'个人云盘',
    buCloud:'企业云盘',
    wasabi:'Wasabi',
    sharePointOnline:"SharePoint Online",
    iCloudPhotos: 'iCloud照片',
    gmail: 'Gmail',
    comingSoon: '敬请期待...',
    iCloudDrive: 'iCloud 云盘',
    signInWith: '登录',
    outlook: 'Outlook',
    fourShared: '4shared',
},
addEmail: {
    connectDesc: '选择您想要添加到MultCloud的邮箱',
    peEmail: '选择并使用邮箱登录',
    iCloudNotice: 'iCloud Drive 暂时无法连接，我们的开发团队正在努力解决这一问题。',
    iCloudPhotosNotice: 'iCloud Photos 暂时无法连接，我们的开发团队正在努力解决这一问题。',
},
cloudExploer: {
    uploadFile: '上传文件',
    newFolder: '新建文件夹',
    newAlbum: '新建相簿',
    search: '搜索',
    grid: '平铺',
    pageList: '列表',
    reFresh: '刷新',
    modified: '修改于',
    openWith: '打开',
    officeOnline: 'Microsoft Office Online',
    loading: '正在加载，请稍后…',
    uploadFolder: '上传文件夹',
    trash: '回收站',
    recentlyDeleted: '最近删除',
    jumpTo: '跳转至',
    deleteForever: '永久删除',
    restore: '还原',
    back: '返回',
    searchResult: '搜索结果',
    emptyTrash: '清空回收站',
    recoverAll: '全部恢复',
    deleteAll: '删除全部',
    fileExists: '文件已存在',
    chooseOption: '文件已存在，请选择执行选项！',
    needRestore: '为了查看该文件夹，请先从回收站还原。',
    limitBoxTip: '1.部分云盘本身会有一些限制。例如，Box不支持传输单文件大小超过2GB的文件。了解更多此类信息，<a href="https://www.multcloud.com/help/limitations.html" target="_blank" class="add-cloud-link">点击此处</a>。<br>2. 如果您的任务在升级成为订阅用户后依然没有10个线程，请取消当前任务之后再重传。您的任务会变为10个线程。',
    fileNameNotEmpty: '输入的文件名不能为空。',
    notContainSpecialChar: '文件名不能含有特殊字符`/ \ | : * ? " < >`。',
    CharacterLimit:'文件名不能含有特殊字符`~"# %& *: < >？ / \ { | }.`',
    pathNotExist: '路径不存在。',
    emptyNotice: '这个文件夹是空的',
    trashEmpty: '回收站为空',
    searchEmpty: '搜索结果为空',
    uploadSize: '上传任务的总大小不能超过1GB。',
    simultaneous: '您最多可以同时添加200个任务。',
    cancelFailed: '取消失败,任务正在创建中，请稍候重试',
    notWith: '文件名和文件夹名不能以“.”开头或结尾。',
    notUpload: '上传失败。',
    sharedDate:'分享日期',
    duplicatePhoto: '重复照片。你正尝试上传的照片为重复项目，因此未导入到你的图库中。',
    dataLoaded: '数据加载完毕',
    failedRestore: '还原文件失败，因为目标目录包含具有相同文件名的文件。',
    //2020-12-11 lijimin
    uploadError:'该文件已被官方云盘禁止下载。',
    downloadLimit: '您已达到今日的下载次数限制，欢迎明天再试哦！',
    //2022-4-26 wt
    createBucket:'储存桶的名称应该只包含小写字母和数字，长度应为3-63个字符。p.s.储存桶的名称不能只由数字组成（如 "12345678"）',
    newBucket:'新建存储桶',
    deleteBucket:'MultCloud不能删除名称全为数字的储存桶（如 "12345678"）。',
    getBucketObjectListFail:'MultCloud无法列出一个名称全是数字的储存桶（如 "12345678"）。',
    newAlubm: '',
    specialCharError: '文件名不能含有特殊字符`/ | : * ? " < >`。',
},
emailExploer: {
    from: '发件人',
    to: '收件人',
    cc: '抄送',
    email: '邮件',
    subject: '主题',
    received: '收件时间',
    sentTime: '发件时间',
    downloadMax200: ' 一次最多可以下载 200 封电子邮件。',
    noSubject: '（无主题）',
    folderName: {
        Inbox: '收件箱',
        Starred: '已加星标',
        Snoozed: '已延后',
        Sent: '已发邮件',
        Drafts: '草稿',
        Important: '重要邮件',
        Chats: '聊天',
        Scheduled: '定时发送',
        AllMail: '所有邮件',
        Spam: '垃圾邮件',
        Trash: '已删除邮件',
        Unread: '未读',
        Categories_Social: '类别_社交',
        Categories_Updates: '类别_动态',
        Categories_Forums: '类别_论坛',
        Categories_Promotions: '类别_推广',
        Categories_Personal: '类别_个人',
    }
},
imageSaver: {
    analyzing: '正在解析',
    failedToParse: '解析失败',
    noviceGuidance: '您可以在这里查看所有最近上传到云端的图片/视频，或是已打包的 Instagram 图片/视频。',
    insDownloadExist: '您已下载过此Instagram个人资料，您可以在“任务列表”中找到它。',
    taskExpiredOn: '于 {time} 过期',
    taskStoringTill: '存储至 {time}',
    taskPart: '压缩包',
    taskUnitFile: '个文件',
    taskUnitFiles: '个文件',
    taskQueue: '等待中',
    taskTabUpload: '上传',
    taskTabSaveAll: '保存所有至云盘',
    taskTabDownload: '下载所有 IG 内容',
    downloadInsVideo: '下载视频',
    downloadSinglePost: '下载整个帖子',
    downloadAllPosts: '下载所有帖子',
    downloadAllReels: '下载所有 Reels',
    downloadAllStories: '下载所有快拍',
    downloadAllHighlights: '下载所有精选集',
    saveInsVideo: '保存视频至云盘',
    saveSinglePost: '保存整个帖子至云盘',
    saveAllPosts: '保存所有帖子至云盘',
    saveAllReels: '保存所有 Reels 至云盘',
    saveAllStories: '保存所有快拍至云盘',
    saveAllHighlights: '保存所有精选集至云盘',
    insCardPosts: '帖子',
    insCardFollowers: '粉丝',
    insCardFollowing: '已关注',
    insTabPosts: '照片和视频',
    insTabReels: 'Reels',
    insTabStories: '快拍',
    insTabHighlights: '精选集',
    insBlankText: '通过 MultCloud 的 Instagram 下载器，轻松下载并保存 Instagram 帖子、Reels、故事和精选集，随时管理您喜爱的内容。',
    webGoogleBlankText: '轻松收集任意网站或谷歌搜索中的图片，高效保存到您的云盘或本地存储中。',
    noTask: '暂无任务',
    inputTipHttp: '输入网站链接或谷歌搜索关键词',
    fetchBtn: '立即获取',
    fetchingBtn: '正在获取...',
    loadMore: '加载更多',
    downloadAll: '下载所有',
    saveAll: '保存所有至云盘',
    saveToCloud: '保存至云盘',
    clearHistory: '清除历史',
    cancel: '取消',
    retry: '重试',
    view: '查看',
    noImage: '未找到内容',
    notSupport: '该链接可能不被支持，请检查链接后重试。',
    inputTipIns: '请输入 Instagram 链接',
    post: '个帖子',
    posts: '个帖子',
    uploadTo: '上传至：',
    download: '下载',
    uploading: '上传中',
    finished: '已完成',
    all: '所有',
    videoInputTip: '请在此处粘贴您的视频链接',
    videoTip: `使用 MultCloud 的无广告跨平台在线视频下载器，从 YouTube、Facebook、X 和 <a href="https://www.multcloud.com/help/video-downloader.html" target="_blank" style="text-decoration: underline;color: #5562B4;">1000+ 个其他网站</a>下载高清视频，无需安装即可使用。`,
    process: '正在处理您的请求...',
    thumbnail: '封面',
    abrTypeVeryHigh: '超高',
    abrTypeHigh: '高',
    abrTypeNormal: '标准',
    abrTypeLow: '低',
    default: '默认',
    generat: '文件生成中',
    retryTip: '任务已重新启动，可在“所有”标签中查看最新进度。',
},
taskList: {
    taskListDes: '您可以在此管理跨云盘传输、跨云盘同步以及分享文件传输任务。',
    multiCloudSync: '多云盘同步',
    MultiCloudTransfer: '多云盘传输',
    nextTransfer: '下次传输',
    scheduled: '定时执行',
    nextSync: '下次同步',
    reTransfer: '再次传输',
    saveNow: '立刻保存',
    transferTasks: '传输任务',
    syncTasks: '同步任务',
    shareTasks: '分享任务',
    backupTasks: '备份任务',
    emailTransferTasks: '邮件传输任务',
    allTime: '所有时间',
    today: '今天',
    latestWeek: '最近一周',
    latestMonth: '最近一个月',
    customDate: '自定义时间',
    allStatus: '所有状态',
    preset: '预设',
    noTaskCreated: '未创建任务',
    createTransferTask: '创建一个传输任务',
    createSyncTask: '创建一个同步任务',
    createRemoteTask: '创建一个离线任务',
    timeMustLess: '开始时间需要早于结束时间',
    taskNameRule: '任务名称不能超过255个字符',
    backupTaskNameRule:'任务名称不能超过255个字符',
    detailNote: '该任务正在准备中，无任务执行详情。',
    notTraffic: '没有足够的数据流量进行云盘之间的传输。',
    reSync:'再次同步',
    rebackup:'再次备份',
    rerestore:'再次还原',
    //2021-10-11
    createBackupTask:'创建一个备份任务',
    createTeamTransferTask:'创建一个团队迁移任务',
    multiClouds: '多云盘',
    speedUP: '提速',
    noTasks: '没有任务',
    noTasksTip: '开启您的首个任务，解锁无缝云间传输与同步。',
    loadingTip: '稍等片刻。',
    allTasks: '全部任务({num})',
},
cloudTransfer: {
    transferDescription: '创建传输任务以在云盘之间传输文件',
    transferOperateFrom: '点击此处以选择作为传输源的云盘或文件夹',
    from: '来源',
    to: '目的地',
    transferOperateTo: '点击此处以选择作为传输目标的云盘或文件夹',
    transferNow: '立即传输',
    transfer: '传输',
    addTaskOnly: '只添加任务',
    addTaskNow: '添加任务并立即传输',
    addBackupTaskNow:'添加任务并立即备份',
    addSyncTaskNow: '添加任务并立即同步',
    transferSucces: '成功传输',
    sureContinue: '您已经选择了超过10个源项目，每个源项目对应一封电子邮件通知。 这意味着您可能会收到超过10封电子邮件。 您确定要继续吗？',
    sure: '是的，我确定。',
    //2020-10-29ljm新增
    sourceRemind:'最多选择200个源项目。请减少选择的源项目或直接选择一整个文件夹。P.S. 一整个文件夹只算做一个项目。',
    backupSourceRemind:'最多选择1000个源项目。请减少选择的源项目或直接选择一整个文件夹。P.S. 一整个文件夹只算做一个项目。'
},
cloudSync: {
    syncDescription: '创建同步任务以在云盘之间同步文件',
    syncOperateTo: '点击此处以选择作为同步目标的云盘或文件夹',
    syncOperateFrom: '点击此处以选择作为同步源的云盘或文件夹',
    syncNow: '立即同步',
    taskEmpty: '任务名不能为空。',
    //2020-10-29ljm新增
    aimRemid:'最多选择200个目标目录。',
    realTimeSync:'即时同步',
    normalSync:'普通同步',
    pause:'暂停',
    paused:'已暂停',
    swicthTwoWay:'切换至双向同步',
    switchOneWay:'切换至单向同步',
    fristSync:'首次同步',
    lastSync:'最後同步',
    initSync:'初次同步正在进行中，请等待。',
    realSyncing:'即时同步运行中...',
    servicesSu:'支持即时同步的云盘',
    addRealDrives:'您需要添加一个支持即时同步的云盘。',
    egDrives:'目前即时同步支持Google Drive、Dropbox、Dropbox Business、OneDrive、OneDrive for Business、G Suite以及box。',
    initTial:'初始化',
    realSync:'实时同步',
    createdAt:'创建时间',
    oneWaySimple:'单向(简单同步)',
    twoWay:'双向(即将推出...)',
    gooleFolder:'如果只是改变Google Drive文件夹下的子文件夹中的内容，同步操作将不会执行。',
    realTimeNotice:'您最多可以同时运行2个实时同步任务，因此一些子任务将被暂停。你确定要继续吗？',
    reachMax:'日志数量已达到最大值，因此仅显示最新的日志。',
    notRun:'任务还未执行。',
    bePaused:'如果实时同步任务保持非运行状态超过7天，任务将被自动暂停。',
    dontShow:'不再显示这个',
    timeOut:'遍历超时',
    outMostly:'遍历超时主要是因为有太多的文件或子目录需要进行实时同步。我们建议通过创建一个普通的同步任务来代替。'
},
emailTransfer: {
    cloudEmail: '邮件传输',
    description: '将您的电子邮件以 PDF 格式传输到云端。',
    migrationSetting: '传输设置',
    cutSetting: '剪切-设置',
    copySetting: '复制-设置',
    settingTips: '',
    notification: '通知',
    watermark: '水印',
    delWatermark: '从下载为PDF的邮件去除水印',
    saveAtt: '保存附件',
    converFormat: '会话格式',
    converFormatTip: '勾选时邮件引用的内容将会被移除。',
    saveOnly: '仅保存最后一条消息',
    optionTitle: '一些电子邮件已存在，您想如何处理这些邮件？',
    filterTitle: '您可以为来源选择框指定额外的过滤条件。',
    filterMessage: '请输入电子邮件，并用逗号隔开',
    filterOption1: '如果会话已更新则覆盖它',
    filterOption2: '总是跳过',
    filterOption3: '重命名',
    filterOption4: '包含附件',
    filterOption5: '未读邮件',
    transferNow: '立即传输',
    filterDateOptions1: '不限时间',
    filterDateOptions2: '一周以上',
    filterDateOptions3: '一个月以上',
    filterDateOptions4: '6个月以上',
    filterDateOptions5: '一年以上',
    filterDateOptions6: '自定义范围...',
    showMore: '展示更多',
    startDate: '开始日期',
    endDate: '结束日期',
},
exception: {
    exceedMaxLimit: '请求数超过最大限度。',
    addCloudFailed: '一些云盘参数没有正确输入',
    cloudNameExist: ' 云盘名重复，请重新输入。',
    pathNotFound: '请检查该路径下的文件或文件夹是否存在。',
    notBeTheSame: '源文件夹与目标文件夹不能相同。',
    notTransferring: '该目录无法执行文件传输，请选择其子目录或其他目录。',
    verifyCodeInvalid: '验证码错误',
    nameEmpty: '云盘名称不能为空',
    emailEmpty: '邮件不能为空',
    serverEmpty: '服务器不能为空',
    usernameEmpty: '用户名不能为空',
    passwordEmpty: '密码不能为空',
    domainEmpty: '域名不能为空',
    bucketNameEmpty: 'Bucket Name不能为空',
    accessKeyEmpty: 'Access Key ID 不能为空',
    secretAccessKeyEmpty: 'Secret Access Key 不能为空',
    keyIdEmpty: 'keyID 不能为空',
    applicationKeyEmpty: 'applicationKey 不能为空',
    sugarSyncWarn: '不支持复制到所选择的目录，请选择"Web Archive","Magic Briefcase","Mobile Photos"目录。',
    flickWarn: '不支持复制到所选择的目录，请选择 "/Albums" 目录。',
    baiDuWarn: '不支持复制到所选择的目录，请选择 "全部文件/我的应用数据/Multcloud" 目录。',
    dropBoxbusinessWarn: '不支持复制到根目录，请选择其他目录。',
    notMediaFiles: '注意：“Albums”目录只能存放相册目录，不能存放媒体文件。',
    notStoreDirectories: '“Photos”目录不能存放文件夹。',
    onlyStoreImages: '注意：“Photos”目录只能存储图片，视频与其他媒体文件，但不能存储文件夹。',
    unknownError: '无法连结到此服务，请重新授权MultCloud访问该服务。',
    renameCloudFailed: '添加云盘失败，请待会重试。',
    deleteCloudFailed: '删除云盘失败，请待会重试。',
    invalidCloudAccount: '该云盘账号不存在。',
    bindEmailFail: '绑定邮箱失败。',
    linkHasExpired: '链接已过期。',
    listItemsFailed: '列出文件失败，请重新添加云盘到MultCloud。',
    deleteItemFailed: '删除失败。',
    renameItemFailed: '重命名失败。',
    createFolderFailed: '新建文件夹失败。',
    moveItemFailed: '移动失败。',
    shareItemFailed: '分享失败。',
    uploadFailed: '未找到文件数据。',
    toFolderIdBlanked: '参数"tid"为空。',
    downloadFileFailed: '下载文件失败，请刷新页面或重新添加云盘至MultCloud。',
    addTaskFail: '添加任务失败。',
    taskQuotaLimit: '你创建的跨云盘传输任务已达到最大数量（1000个），请删除部分之前创建的任务。',
    deleteTaskFail: '删除任务失败。',
    maxRunningLimit: '正在执行的任务已达到最大数量限制，该任务会以等待状态添加。',
    userCreateFail: '创建用户失败，请稍后重试。',
    userUpdateFail: '修改账号信息失败，请刷新页面后重试。',
    createSaltFail: '登录失效，请重新登录。',
    listFolderFailed: '列出文件夹失败，请重新添加云盘。',
    cloudCategoryInvalid: '该云盘已经不被支持。',
    executeTaskFail: '执行任务失败，请检查您的网络连接。',
    parameterInvalid: '参数无效',
    saltInvalid: '登录失效，请重新登录。',
    emailInvalid: '无效邮箱。',
    notAuthorized: '用户名或密码无效。',
    cloudNameEmpty: '显示名称不能为空。',
    addCloudExpired: '添加云盘失败，请重新添加云盘。',
    verifyCodeInvalid: '验证码失效。',
    emailExist: '邮箱已存在。',
    exceedMaxLimit: '请求数已达到最大限制。',
    userIdNotNull: 'Userid为空。',
    notFoundTask: '未找到任务。',
    noTaskRunning: '无正在执行的任务',
    userNotFound: '未找到用户',
    loginerNotFound: '登录方式不支持',
    deletePermissionLimited:'您不能继续进行这项操作，因为您没有 "删除权限"',
    notHaveDeletePermission: '您没有删除该文件/文件夹的权限。',
    uploadPermissionLimited:'您不能继续进行这项操作，因为您没有 "上传权限"',
    movePermissionLimited:'您不能继续进行这项操作，因为您没有 "移动权限"',
    copyPermissionLimited:'您不能继续进行这项操作，因为您没有 "复制权限"',
    notHavePermission: '由于缺乏写入权限，您无法粘贴此文件/文件夹',
    mkdirPermissionLimited:'您不能继续进行这项操作，因为您没有 "创建文件夹权限"',
    notCreatPermission: '由于缺乏写入权限或空间不足，您无法创建存储桶或文件夹。',
    renamePermissionLimited:'您不能继续进行这项操作，因为您没有 "重命名权限"',
    creatIDriveFolderError: '对象名称包含不支持的字符。',
    creatIDriveFolderToLong: '文件夹名称不能超过245个字符。',
    noUploadPermission: '由于缺乏上传权限或云盘空间不足，您无法上传此文件。',
    bucketNameLongError: '存储桶名称长度必须为 3 到 63 个字符，只能使用小写字母、数字、点 (.) 和连字符 (-)，以字母或数字开头和结尾，并避免连续句点。',
    bucketNameIsNotIp: '存储桶名称不能是IP地址。',
    downloadPermissionLimited:'您不能继续进行这项操作，因为您没有 "下载权限"',
    ipNotFound: 'ip未找到',
    onlyAlbum: '只有由MultCloud创建或分享的相册目录才能被选择用于存放图片，视频等媒体文件。',
    createFolderFail: '创建文件夹失败',
    parametersNotEmpty: '云盘参数不能为空。',
    //mega报错
    addMegaFailed: '一些云盘参数没有正确输入或者您已激活F2A。',
    //mySql报错
    mySqlWarn:'此雲無法作為雲端到雲端傳輸的目標雲。',
    //2020-10-29ljm新增
    maxTaskRemind:'已达到5000个传输/同步任务的上限。请在删除部分任务后重试。P.S. 如果一个任务中包含三个源项目，则该任务将会被记为三个任务。',
    // 2020-11-25 yjs
    torrentTort:'该文件涉嫌侵权',
    //2020-12-4 xth
    shareNotUpload:'分享者已经关闭 \"允许上传\" 功能, 请刷新页面。',
    //2020-12-9 xth
    shareItemUpdate:'分享者已更改该分享链接的权限，请刷新页面。',
    nameLong:'用户名不能超过20个字符。',
    notOpened:'该云盘不支持即时同步。',
    taskNotFound:'该任务不存在。',
    subscribeFail:'创建任务失败。',
    driveAccountIdInvalid:'无法创建实时同步任务。请删除并重新添加所选的云服务，然后重试。',
    unknownState:'无法执行该操作，请稍后重试。',
    InvalidParameter:'无效的参数。',
    InvalidDirectory:'box根目录不支持该功能。',
    notPermission:'你没有对该团队文件执行“允许上传”操作的权限。',
    HasExist:'该文件夹即时同步任务已存在，请取消该文件夹的即时同步任务，再重新在该文件夹创建。',
    // taskRunningNumberLimited:'您可以并行5个跨云任务，请取消一个正在运行的任务并重新尝试。',
    taskRunningNumberLimited:'现在已经有2个实时同步任务处于运行状态，请先暂停其中一个任务。',
    reachedLimit:'已达到该云的速率限制，请稍后重试。',
    selectAlbumWarn:'小贴士：相簿目录只能储存图像、视频和其他媒体文件，而不能存储目录。',
    notSupported:'目前即时同步功能不支持多目标同步任务。',
    incorrectFormat:'抱歉，您的电话号码格式不正确',
    taskMaximumNumberLimited:'您已达到 200 个实时同步任务的最大数量。 请删除一些不必要的实时同步任务，然后重试。',
    autoLoginFail: '您已经激活了两步验证，请再次登录。',
    unsubscribeFail:'删除失败',
    //云盘操作报错
    alreadyAdd:'您已经添加了该云盘。',
    toggleWhileEditing:'您添加的账号与当前账户不匹配。',
    unsubscribeFail:'删除失败',
    //2022-4-25 wt(wasabi)
    emptyBucket:'您不能删除非空的储存桶。P.S. 请确保Wasabi储存桶的版本管理中也没有任何文件/文件夹。',
    cannotCopyFolder:'不能将文件夹复制到同一个存储桶中。',
    cannotCopyIdrivee2Folder: '同一 Idrive e2 账号下的文件夹不能相互复制。',
    cannotCutFolder:'同一存储桶下的文件夹不能相互剪切并粘贴。',
    bucketAlreadyExists:'请求的存储桶名称不可用。存储桶命名空间由系统的所有用户共享。请选择其它名称重试。',
    accessPermissionLimited:'您无权限访问这个文件夹。',
    accessDenied:'访问被拒绝，您无权执行此操作。',
    shareTransferCanotCopy: '目前尚不支持对多项目分享的根目录进行复制操作。',
    // 2022-6-8 wt 
    sharePointOnlineNotTrans:'无法选择SharePoint的根目录来传输文件，请选择网站的子目录.',
    sharePointListFailed:'Error 500: InternalServerError. 提示：请检查该账户是否可以访问SharePoint服务。',
    sameDirError: '来源账户和目标账户不能相同。',

    accessDenied:'访问被拒绝',
    //iCloudPhotos报错
    onlySaveAlbums: '注意：您选项的目标目录只能保存相簿（文件夹）。',
    notSelectICloudPhotosRoot: '注意：iCloud 照片的根目录只能保存相簿（文件夹）。',
    notSelectICloudPhotosForder: '注意：您选项的目标目录只能保存相簿（文件夹）。',
    notSelectICloudPhotosAlbum: '注意：您选择的目标目录只能保存图片（不能保存文件夹）。',
    notSelectICloudPhotosOther: '注意：您选择的目标目录无法直接保存图片，所有传输的图片都会被保存到“最近项目”中。',
    notSelectICloudPhotosBackup: '无法将 iCloud 照片作为“云备份”的目标，要将图片保存在 iCloud 照片中，请选择“跨云盘传输”和“跨云盘同步”。',
    notSelectICloudPhotosSyncRoot: '注意：无法将图片同步至 iCloud 照片的根目录。',
    notSelectICloudPhotosSync: '这是 iCloud 照片中的文件夹，您只能将图片同步到 iCloud 照片的相簿中。',
    sendTooMany: '验证码发送频繁，输入其中一台设备收到的最新验证码，或者稍后重试。',
    verifySecurityCodeFailed: '验证失败，请检查并重新输入验证码。',
    appleNotEnablePhotos: '你的 Apple ID 不能用于 iCloud 照片。要使用 iCloud 照片，请通过你在 Apple 设备上使用的 Apple ID 登录。',
    tooManyRequests429: '超出用户速率限制。请在 {date} 之后重试',
    tooManyRequests403: '同时发起的请求过多，请稍后重试。',
    // iCloudDrive报错
    folderNameIsTooLong: '文件夹名称不能超过 255 个字符。',
    fileNameIsTooLong:'文件名不能超过 250 个字符。',
    iCloudDriveNotEnoughSpace: '空间不足，无法上传文件。',
    uploadFileIsTooBig: '文件太大无法上传，MultCloud目前允许上传的文件大小上限为 100 MB。',
    uploudFileSizeIsZero: '无法将零字节文件上传到 iCloud 云盘。',
    notUploudSpecialFile: '无法将此类文件上传至该 App 资料库。',
    notRenameApp: 'Apple 不允许修改 App 文件夹的名称，如 Pages 文稿、Numbers 表格和 Keynote 讲演。',
    ErrorDeleteDistinguishedFolder: '无法删除特殊文件夹。',
    moreThan256Characters: '文件夹名称不能超过 256 个字符。',
    cloudNotFound: '您已移除该云盘。',
    fourSharedUnauthorized:'您的4shared授权已过期。请点击“重新添加”重新授权您的账号。',
    fileFolderNameLengthExceed:"文件/文件夹名称长度不能超过 255 个字符。",
    invalidLink: '无效链接。',
    requestFailed: '请求失败。',
    exceeds2GB: '文件大小超过 2GB，无法下载。',
    licenseUpgradError: '由于您是{scheme}订阅用户，该注册码不可用',
    noLicenseCode: '请输入注册码',
    licenseCodeError: '输入的注册码不正确',
},
preview: {
    fileNotReview: '文件无法查看',
    goOringinalSite: '跳转至该云盘'
},
remoteTask: {
    remoteTask: '离线任务',
    createTask: '创建任务',
    successsExceed: '成功执行该操作',
    operateSuccess: '执行成功',
    noRemote: '尚未创建离线任务',
    unKnownError: '未知错误',
    undefinedDisk:'无法找到目标目录,请先复制该任务的链接,再重新创建一个离线任务',
    taskExpired:'该任务已过期，请重新创建任务',
    createDescribe:'将URL文件、种子文件、磁力链接文件直接保存到您的云盘。',
    saveURLDescribe:'将URL文件离线传输到您的云盘',
    excuteNow:'立即执行',
    noSeeds:'资源较少',
    failedToParse:'解析失败',
    parseMagnetRunning:'正在解析资源，请稍后...',
    selectedFileLimit:'所选文件总量不能超过500个或者大小超过50G',
    addLink: '添加链接',
    startEmailSend: '结束任务时发送邮件通知',
    nowUpload: '立即上传',
},
shares: {
    myShares: '我的分享',
    savedShares: '保存的分享',
    sharedOn: '分享时间',
    allowedTo: '允许上传',
    location: '位置',
    shareNull: '您没有分享任何文件。',
    shareNullTips: '小贴士：右键选中一个文件，再按下“分享”按钮，即可分享文件。',
    savedShareNull: '您没有保存任何分享文件。',
    savedShareNullTips: '小贴士：您可以快速访问保存在此的分享链接。',
},
login: {
    experienceSigning: '使用游客账号体验',
    forgotPassword: '忘记密码？',
    signIn: '登录',
    rememberMe: '记住我',
    keepLogin: '保持登录',
    loginWith: '使用其他方式登录',
    email: '电子邮件',
    password: '密码',
    verificationCode: '验证码',
    firstName: '姓',
    lastName: '名',
    confirmPassword: '确认密码',
    createAccount: '创建账户',
    continueWith: '或使用',
    resetMessage: '发送重置邮件',
    enterEmail: '请在下方输入您注册时使用的邮箱，我们将向它发送一份用于重置密码的邮件。',
    enterCorrectEmai: '请输入正确的电子邮件格式。',
    passwordCharacters: '密码必须为8-16位字符',
    passwordDiff: '两次输入的密码不一致。',
    enterCode: '请输入验证码。',
    sentSuccess: '邮件已成功发送。',
    successfully: '注册成功',
    pleaseEmail: '请输入您的邮箱',
    pleasePassword: '请输入您的密码',
    accountActivated: '您的账号尚未激活',
    enterCorrectPass: '请输入正确的邮箱地址或临时账号和密码。',
    resetPasseord: '为了您的账号安全, 请点击“忘记密码” 修改密码',
    validEmail: '请输入有效的邮箱',
    enterFirstName: '请输入您的姓氏',
    enterLastName: '请输入您的名字。',
    reEnterPass: '请再次输入您的密码。',
    creatingAccount: '创建账户即表示您同意',
    termsUse: '使用条款',
    privacyPolicy: '隐私侦测',
    thankYou: '谢谢您！',
    checkEmail: '请查看您的电子邮件',
    confirmRegistration: '请激活您的邮箱。您可以跳过该激活步骤正常登录并使用我们的产品，但如果您输入的邮箱有误，我们将无法找回您的账号。',
    noteReceiveEmail: '没有收到邮件？',
    receiveConfirmationEmail: '如果您没有收到确认邮件，请发送邮件到',
    buttonResend: '或者点击此按钮重新发送',
    forgetEmail: '忘记了您的电子邮件地址？',
    sendEmailSupport: '联系我们的客服',
    trackDown: '我们会跟进。',
    passwordnotMatch: '您输入的密码不匹配',
    enterVaildPassWord: '请输入有效的密码',
    usernameNotContain: '用户名不能包含特殊字符。',
    updatedSuccessfully: '您的数据已成功更新',
    thankBindEmail: '感谢您绑定电子邮件地址，请及时检查激活电子邮件',
    failExceedOperation: '无法超过此操作',
    enterNewPassword: '请输入新密码',
    confirmationPassword: '请输入确认密码',
    userNameNot: '用户名不能为空',
    //login popup用
    signUp: '注册',
    logInButton: '登录',
    logInWith: '快速登录',
    logToMultCloud: '登录MultCloud',
    logEmailInput: '邮箱/临时账号',
    verificationIncorrect: '您输入的验证码不正确。',
    signUpTitle: '注册并获得每月5GB的免费流量',
    title: "用MultCloud将它传输到您的云盘",
    tips: "已拥有一个账号？",
    tips2: "没有账号？",
    btnTxt: "正在登陆。。。",
    facebook: "Facebook",
    google: "Google",
    exception: {
        strEmpty: "请填写此栏。",
        nameToLong: "你的用户名必须是1-20个字符。",
        emailError: "请输入有效的电子邮箱地址。",
        pwdError: "请输入8-16个字符的密码。",
        rePsdEmpty: "请重新输入密码。",
        rePwdError: "密码不匹配。",
        codeEmpty: "请输入验证码。",
        codeError: "验证码必须为4个字符。",
        verifyCodeInvalid: "验证码不正确。",
        emailExist: "该电子邮箱地址已被注册。",
        emailPsdError: "电子邮箱/临时帐户名或密码不正确。",
    }
},
home: {
    driveNameNotContain: '云盘名称不能含有特殊字符`/ \ | : * ? " < >  &`',
    cloudDiskName: '云盘名称不能超过200个字符'
},
sharesPage: {
    linkFailure: '对不起，该分享已被取消。',
    linkMasking: '对不起，该分享已被禁止访问。',
    saveCloud: '保存到云盘',
    directDownload: '下载',
    saveLink: '保存链接',
    cancelShare:'取消分享',
    uploadFile: '上传文件',
    newFolder: '新建文件夹',
    saveLinkSuccessBefore: '您已成功保存链接',
    saveLinkSuccessAfter: '查看已保存链接',
    saveLinkFail: '保存链接失败',
    downloadingFolder: '目前不支持下载文件夹。。',
    downloadingMore: '您一次只能下载一个文件。',
    downloadingNone: '请选择一个文件。',
    sharecanceledSuccess: '取消分享成功。',
    sharecanceledFailed: '取消分享失败。',
    newFolderInRoot: '请进入子目录新建文件夹。',
    uploadFileInRoot: '请进入子目录上传文件。',
    selectFileTransfer: '请选择一个需要传输的文件。',
    createTransferFailed: '创建传输任务失败',
    createTransferSuccessBefore: '您已成功创建一个传输任务',
    createTransferSuccessAfter: '查看任务',
    addCloudService: '添加云盘',
    mustAddClouds: '您必须添加一个有效云盘',
    selectSaveCloudTitle: '请选择',
    moreClouds:'更多云盘',
    saveLinkExists: '该链接已经存在。',
    errorShare404: '未找到源文件。',
    passWordError: '密码错误！',
    passWordNone: '密码不能为空。',
    passWordInputTitle: 'MultCloud私人分享',
    passWordInputMsg: '请输入密码。',
    passWordInputButton: '确定',
    loginErrorMax: '您长时间没有更新密码，为了确保您的账号安全，请修改密码。',
    uploadFolder: '目前您只能上传文件。',
    pleaseSignIn: '请登录MultCloud。',
},
share:{
    noManageMyShare: "您可以在这里管理所有分享文件。",
    noManageSavedShare: "您可以管理所有保存的分享。",
    unknownError: "无法找到该分享文件，该文件可能已被移动或删除。",
    privateShareText: "（请联系本人以获取密码）",
},
inviteFriends:{
    titleBefor: '邀请尽可能多的好友，每个您邀请的好友将给您带来 ',
    titleAfter: ' 流量！无流量限制！',
    shareEmailTitle: '分享邀请：',
    shareLinkTitle: '分享邀请链接：',
    emailSend: '发送',
    emailTip: '在此输入Email地址',
    wonMonthFlows: '您本月获得的跨云盘传输流量（终身有效）：',
    wonMonthTitle: '得到赢取终身无限流量的机会！',
    lastWinner: '上一位获奖者 ',
    winnerInvites: '通过{num}个邀请',
    winnerTip: '赢得了终身无限流量',
    statusTitle: '您的分享状态',
    successInvites: '本月成功的邀请数：',
    chanceWin: '赢取大奖的概率：',
    tipsTitle: '活动规则',
    tipsOne: '只有被邀请用户在验证了邮箱后，记为一次成功的分享。',
    tipsTwo: '通过邀请获得的流量无最大上限。',
    tipsThird: '如果您目前已经拥有无限流量服务，您将无法从成功的分享中获得2GB的流量，但是您赢得终身无限流量的概率会加倍。',
    shareText: 'MultCloud-在一个平台传输和管理您的多个云盘。 立即加入MultCloud，即可获得2 GB的跨云端传输流量奖励！',
},
paySystem:{
    billed:'以$0.099/GB的单价购买额外流量',
    subCould:'如果流量仍不够用，订阅用户可以按照50GB/$5.9或100GB/$9.9的价格购买流量。',
    limitedMonth:'150GB/每月',
    limitedTrafficMonth:'150GB 流量/每月',
    unlimitedTraffic:'终身无限流量！',
    foraYear:'一年无限流量',
    noNeedPurchase:'无需购买额外流量',
    yearlyPayment:'按年付费(¥47.42/每月)',
    validityData:'您购买的流量终身有效',
    additionalPackage:'额外流量包',
    subscriptmc:'您的MultCloud订阅方案',
    upgradeMore:'升级到MultCloud付费版即可获得更多的流量与额外的功能',
    recommended:'推荐方案',
    toUnlimited:'升级到无限版',
    otherPlan:'其他方案',
    moreTraffic:'购买更多流量',
    monthlySubscriber:`您是一个月订阅用户，而您每月将拥有150GB跨云盘传输或同步流量，`,
    moreDetails:`<a class='add-cloud-link sysLink'>更多特权详情 >></a>`,
    dataTraffic:'本月流量使用情况',
    cloudTraffic:'跨云盘流量',
    buyNow:'立刻购买',
    specialOffer:'特别优惠',
    lifetimeFree:'终身免费',
    unsubscribe:'取消订阅',
    includes:'包含',
    reSubscription:'激活订阅',
    monthTraffic:'一月无限流量',
    threeMonth:'30GB/每月',
    monthlyPayment:'按月付费',
    monthlyUnlimited:'月无限',
    gb:'GB',
    YearlyUnlimited:'年无限',
    YearlyPaymentNine:'按年付费(¥63.25/每月)',
    YearlyPayment:'按年付费',
    Onetime:'一次性付费',
    twoMonthree:'200GB/每月 x3',
    QuarterlyPayment:'按季付费(¥53/每月)',
    fourMOne:'400GB/每月 x12',
    quarterlySubscriber:`您是一个季订阅用户，而您每月将拥有200GB跨云盘传输或同步流量，`,
    yearlySubscriber:`您是一个年订阅用户，而您每月将拥有400GB跨云盘传输或同步流量，`,
    expireIn:'到期时间',
    billYearly:'每年支付',
    billMonthly:'每月支付',
    billQuarterly:'每季支付',
    twoMonTrafficthree:'200GB 流量/每月 x3',
    fourMTrafficOne:'400GB 流量/每月 x12',
    deleteSubAccount:'您必须取消订阅才能删除账号，是否取消订阅?',
    payFirst:'您必须先',
    paybindEmail:`<a class='add-cloud-link sysLink'>绑定并且验证您的邮件地址</a>`,
    payEnd:'才能订阅，因为我们需要确保您能成功收到订阅相关的重要邮件。',
    yearlyPaymentTxt:'按年付费',
    quarterlyPaymentTxt:'按季付费',
     //2021-5-20新加
    upUnlimited:'升级到年无限',
    payDiff:'只需要支付差价!',
    yearlyUnlimit:'MultCloud (<b>年无限</b>)',
    providesUnlimited:'年无限计划提供无限的数据流量，以在云服务之间传输或同步数据，为期12个月。',
    subProduct:'这是一种订阅产品，每年收费',
    perYear:'。',
    cancelSubscription:'您可以随时取消订阅。',
    defaultPayment:'默认付款方式是',
    anotherPayment:'如果您想使用其他付款方式，请 ',
    clickHere:'点击此处',
    tryAgain:'付款暂时无法完成。 请检查您的付款方式，然后重试。',
    contactPayment:'如果付款有问题，请随时联系<a href="mailto:support@multcloud.com">support@multcloud.com</a>',
    Notice:'通知',
    beforeBind:'请在升级会员前绑定您的邮箱。',
    processorder:'订单处理中',
    eachGbMoney:'¥0.7/',
    eachGbMoneyT:'¥0.59/',
    payCouponQuartly:'按季付费(¥39.67/每月)',
    payCouponlimitedYearly:'按年付费(¥36.58/每月)',
    payCouponunlimitedYearly:'按年付费(¥47.42/每月)',
    payCouponunlimitedYearlyLow:'按年付费(¥42.17/每月)',
    tips:'提示：如果您遇到任何问题，请随时联系  <a href="mailto:support@multcloud.com">support@multcloud.com</a>.',
    monthly:'每月150GB',
    //新版付费页面
    payTitle: '选择最适合您的 MultCloud！',
    limitedData: '有限数据',
    unlimitedData: '无限数据',
    monthly: '月付',
    annually: '年付',
    save58: '节省58%',
    payTip: '联系我们的销售团队',
    limitTips: '未使用的数据流量会累积',
    unlimitTips: '已无数据限制的问题',
    tips2: '如果您在网上购买过程中遇到任何问题，请随时与我们联系: <a href="mailto:support@multcloud.com">support@multcloud.com</a>',
    vipUpgradeTips: '这是提供给{type}计划用户的优惠。',
    tabPayScheme: {
        perMonth: '每月付款',
        perYear: '每年付款',
        perNextYear: '第一年 (续费为 {price})',
        refundDays: '天的退款保证',
        advanced: '高级功能',
        payPremium: '升级到任何高级版本，就能享受以下所有的高级功能 ',
        payUnlimited: '升级到任何无限版本，就能享受以下所有的高级功能',
        freeTip1: '更多的云到云数据流量',
        freeTip2: '无限的云到云数据流量',
        freeTip3: '计划的传输/同步/备份',
        freeTip4: '双重同步',
        freeTip5: '10条传输线程',
        freeTip6: '8种同步模式',
        freeTip7: '文件筛选器',
        freeTip8: 'VIP传输服务器',
        freeTip9: 'VIP客户服务',
        freeTip10: '同时运行5个跨云任务',
        freeTip11: '无限次邮件转换',
        freeTipTitle1: '订阅者可以同时创建2个实时同步任务和2个普通同步任务(总共4个)。',
        freeTipTitle2: '订阅者可使用10个传输线程，而免费用户可使用2个传输线程。',
        freeTipTitle3: '双向同步和7个自定义选项的单向同步，支持镜像同步。',
        freeTipTitle4: '设置过滤器，从而自动传输或同步用户定义的文件名或某些扩展名的文件。',
        freeTipTitle5: '订阅用户可以并行5个跨云的任务，免费用户可以同时运行一个任务。',
        freeTipTitle6: '订阅者可无限次地将邮件转换为PDF，而免费用户每月最多可转换50封邮件。',
    },
    nowPayScheme: {
        clearInsCountText: '但未使用的 Instagram 个人资料下载配额将被清除。',
        manageYourPlan: '管理您的订阅',
        price: '价格',
        paymentMethon: '付款方式',
        autoRenewal: '自动续订',
        priceVat: '包括 {currency}{vatPrice}增值税 ({currency}{netPrice}的{percent}%)。',
        defaultPayment: '{method}, xxxxxxxx{num}。',
        paypalPayment: '默认支付方式为PayPal。',
        changePayment: '修改支付方式',
        activated: '下一个账单日期 {time}',
        deactivated: '下一个账单日期 {time}',
        appleTip: '您目前的订阅{name}是在苹果商店购买的。',
        appleTipId: '苹果交易ID：{id}。',
        googleTip: '您目前的{name}是在Google Play购买的。',
        googleTipId: 'Google Play 订单ID：{id}。',
        appNextTimeTip: '自动续费已激活，下次计费日期是{time}。',
        appNoSubscribe: '自动续费功能已关闭。',
    },
    // 免费用户弹窗
    freePlanPopup: {
        title_traffic: '云到云传输流量不足',
        title_ins: '您已达到下载上限',
        title_pdf: '您已达到电子邮件转换为 PDF 的数量限制',
        title_modes: '您选择的同步模式仅限于高级方案',
        title_remote: '您已达到离线上传的限制',
        title_subtasks: '升级到付费方案即可传输更多子账号',
        title_scheduled: '定时传输/同步/备份仅限于高级方案',
        title_speed: '五倍传输速度仅限于高级方案',
        title_sync: '您已达到普通同步的限制',
        title_real: '您已达到实时同步的限制',
        title_filter: '文件过滤仅限于高级方案',
        desc: '升级以解锁所有高级功能',
        itemTitle_th: '功能和权益',
        itemTitle_traffic: '云到云流量',
        itemTitle_ins: '下载Instagram个人资料',
        itemTitle_pdf: '将电子邮件转换为PDF',
        itemTitle_modes: '同步模式',
        itemTitle_remote: '同时执行的离线上传任务数量',
        itemTitle_subtasks: '团队间可迁移子账号数量',
        itemTitle_scheduled: '定时传输/同步/备份',
        itemTitle_speed: '传输速度',
        itemTitle_sync: '同时执行的普通同步任务数量',
        itemTitle_real: '同时执行的实时同步任务数量',
        itemTitle_filter: '文件过滤',
        itemTitle_tran: 'VIP传输服务器',
        itemTitle_customer: 'VIP客户支持',
        itemTitle_watermark: '从转化为PDF的邮件去除水印',
        itemValue_cur: '当前方案',
        itemValue_free: '免费版',
        itemValue_upgrade: '升级至',
        itemvalue_premium: '高级版',
        itemvalue_5gb: '5 GB / 月',
        itemvalue_1profile: '1次 / 月',
        itemvalue_50emails: '50封邮件 / 月',
        itemvalue_maxUnlimited: '至多无限',
        itemvalue_unlimited: '无限',
        button: '升级仅需 ¥ 64 起',
    },
    // 套餐的支持项
    supportItem: {
        yourCurPlan: '当前方案',
        // 第1组
        gb5: '每月5GB的免费数据流量',
        gb100: '每月100GB的数据流量',
        gb200: '每月200GB的数据流量',
        gb1200: '每年1200GB的数据流量',
        gb2400: '每年2400GB的数据流量',
        gbUnlimitedYear: '每年不限数据流量',
        gbUnlimitedLifetime: '终身不限数据流量',
        gbPackage50: '',
        gbPackage100: '',
        gbGiveAway500: '',
        gbGiveAway200: '',
        ins1: '每月可下载 1 个 Ins 个人档案',
        ins10: '每月可下载 10 个 Ins 个人档案',
        ins20: '每月可下载 20 个 Ins 个人档案',
        ins120: '每年可下载 120 个 Ins 个人档案',
        ins240: '每年可下载 240 个 Ins 个人档案',
        insPackage50: '',
        insPackage100: '',
        insGiveAway500: '',
        insGiveAway200: '',
        pdf50: '每月转换50封邮件',
        pdfUnlimited: '无限次邮件转换',
        threads2: '2个线程用于数据传输',
        threads10: '10个线程用于数据传输',
        scheduled: '定时传输/同步/备份',
        // 第2组
        acrossClouds: '云传输/同步/备份',
        offline: '离线传输/同步/备份',
        subAccounts3: '在团队间迁移 3 个子账户',
        subAccounts1000: '在团队间迁移 1000 个子账户',
        highSpeed: '高速数据传输',
        // 第3组
        syncMode4: '4种单向/双向同步模式',
        syncMode10: '10种单向/双向同步模式',
        realSync: '实时同步',
        passwordProtected: '受密码保护的共享',
        subAccounts: '子账号协作',
        // 第4组
        cloud30: '30+ 领先的云存储服务',
        unlimitedCloud: '添加云盘帐户 无限制',
        singleLog: '单次登录所有云盘',
        support365: '24/7/365 优先支持',
        // 其他
        unlimitedDataTraffic: '无限的云对云传输流量',
        unlimitedInsProfile: '无限 Instagram 个人资料下载',
        unlimitedAllFeatures: '所有高级功能',
        // VIP弹窗标题
        vipPopupTitleTraffic: '您已消耗完所有传输流量',
        vipPopupDescTraffic: '升级到付费方案即可解锁无限传输流量',
        vipPopupTitleIns: '您已用尽所有Instagram个人资料的下载次数',
        vipPopupDescIns: '升级到付费方案，下载无限Instagram个人资料',
    },
    //套餐arguments参数翻译
    arguments: {
        //参数名
        title: {
            monthly100GB: '100GB / 月',
            monthly200GB: '200GB / 月',
            monthlyUnlimit: '无限月订阅',
            yearly1200GB: '1200GB / 年',
            yearly2400GB: '2400GB / 年',
            yearlyUnlimit: '无限年订阅',
            lifetimeUnlimit: '终身无限计划',
            package50GB: '50 GB',
            package100GB: '100 GB',
            giveAway500GB: '500GB',
            giveAway200GB: '200GB',
        },
        tips: {
            monthly100GB: '例如，您在第一个月只消耗了100GB中的50GB，那么下个月您仍有50GB 的额外数据流量。',
            monthly200GB: '例如，您在第一个月只消耗了200GB中的150GB ，那么下个月您仍有50GB 的额外数据流量。',
            monthlyUnlimit: '',
            yearly1200GB: '例如，第一年您只消耗了1200GB中的1000GB，那么明年您还有200GB 的额外数据流量。',
            yearly2400GB: '例如，第一年您只消耗了2400GB中的2000GB，那么明年您还有400GB 的额外数据流量。',
            yearlyUnlimit: '',
            lifetimeUnlimit: '',
            package50GB: '例如，您这个月只消耗了50GB中的20GB，那么未使用的30GB将在下个月仍然存在。',
            package100GB: '例如，您这个月只消耗了100GB中的20GB，那么未使用的80GB将在下个月仍然存在。',
        }
    },
},
//双重验证功能
twoStepverification:{
    bind:'请先绑定邮箱',
    addVerify:'您必须添加验证方式。 ',
    phoneNotEmpty:'电话号码不能为空。 ',
    addPhone:'添加电话号码',
    addAlEmail:'添加备用电子邮箱地址',
    verifySet:'验证设置',
    addWayVerify:'添加验证方式',
    enterEmail:'输入您的电子邮箱地址',
    enterPhone:'输入您的电话号码',
    enterCode:'请输入我们发送的验证码',
    enterCodeTip:'请检查您的垃圾邮件文件夹并报告不是垃圾邮件，或将 "no-reply@multcloud.email "添加到您的白名单。',
    codeExpired:'验证码已过期',
    codeinCorrect:'验证码不正确，请检查验证码并重试。 ',
    verificationTurnOn:'开启双重验证',
    recoverAccess:'如果您需要恢复对账号的访问权限，此代码将有所帮助。您应该将其写下来并存放在安全的地方。我们强烈建议您不要将恢复代码存储在设备上。 ',
    longValid:'如果您以前有恢复代码，则它不再有效。请改用此新恢复代码。 ',
    removeAll:'移除所有设备？ ',
    lostAccess:'如果您无法访问您信任的设备，我们建议您执行此作业。 ',
    removeMethod:'删除验证方法？ ',
    removeMethodSure:'您确定要删除验证方法吗？删除它意味着您将无法使用它进行验证。 ',
    getRecode:'生成新恢复码',
    emailCode:'通过电子邮件发送验证码',
    TextCode:'通过短信发送验证码',
    useAccount:'您现在使用的是临时账号，请绑定邮箱地址，然后重试。',
    removeTrusted:'移除所有受信任的设备',
    finish:'完成',
    newCode:'您的新验证码是',
    twoStep:'双重验证',
    twoStepis:'双重验证已',
    on:'开启',
    off:'关闭',
    cancel:'取消',
    toManyCodeSend:'验证码发送过于频繁',
    verifyIdenti:'验证身份',
    codeCopied:'成功复制密码！',
    copyCode:'复制密码',
    trustedDevice:'已移除受信任的设备！',
    phoneValueTips:'提示: 请去掉最开头的零，并移除所有空格、破折号或括号。',
},
cloudBackup:{
    cloudBackup:'云备份',
    setUpCloud:'设置云备份任务，将在线文件从一个云备份到另一个云',
    filesBckupTarget: '目标目录',
    filesBckup:'文件备份',
    selectSoure:'按一下此处选择要备份的源云文件',
    saveBackup:'备份位置',
    selectTarget:'单击此处选择目标云以保存备份',
    backupNow:'立即备份',
    canSelect:'最多可选择10000个项目',
    backupFiles:'您无法将文件备份到Google相簿。 ',
    notSelectEvernoteBackup: ' 您无法将文件备份到Evernote。',
    backFlickr:'您无法将文件备份到Flickr。 ',
    thankSubscrib:'感谢您订阅我们的服务，您现在最多可以同时备份10个文件。 ',
    maximunBack:'您现在最多可以同时备份2个文件。升级到任何高级服务后，最多可备份10个！ ',
    backSuccess:'备份成功',
    backFailure:'备份失败',
    successBck:'成功备份所有文件',
    taskCanceled:'任务被手动取消',
    notRestore:'找不到要恢复的文件。它们可能已经被删除。 ',
    selectVersions:'选择版本',
    restoreOptions:'恢复选项',
    selectFiles:'选择要恢复的文件。 ',
    toRestore:'请选择一个文件进行恢复。 ',
    originalLocation:'原始位置',
    thankRestore:'感谢您订阅我们的服务，您现在最多可以同时恢复10个文件。 ',
    restoreSimult:'您现在最多可以同时恢复2个文件。升级到任何高级服务后，最多可恢复10个！ ',
    restoreSuccess:'恢复成功',
    restorePartial:'部分恢复成功',
    restoreFailure:'恢复失败',
    notRestore:'找不到要恢复的文件。它们可能已经被删除。 ',
    backupTime:'备份时间',
    changedFiles:'已更改的文件',
    deleteVersion:'确定要删除备份版本吗？ ',
    deleteFiles:'删除此版本中的文件',
    keepLatest:'保留最新文件',
    overWriteFile:'覆盖文件',
    skipFile:'跳过文件',
    versions:'版本',
    backupTask:'备份任务',
    readdCloud:'重新添加云盘',
    selectedCloud:'在云备份发布之前，部分选定的云盘已添加到MultCloud，我们建议您将这些云盘重新添加到MultCloud并重试。 ',
    continueAnyway:'仍然继续',
    selectedHasAdded:'选定的云盘在云备份发布之前已添加到MultCloud，我们建议将这些云盘重新添加到MultCloud并重试。 ',
    failCreate:'创建备份任务失败。',
    failLoad:'加载失败',
    pleaseReAdd:'请将云盘重新添加到MultCloud。',
    alreadyAdd:'您已经添加了该云盘。',
    failRename:'未找到对应的文件，重命名失败',
    taskRuning:'任务正在运行，待任务结束后再试',
    //2021-08-07添加
    oneBackup:'您只能同时执行一个备份或还原任务',
    restoreTask:'还原任务',
    restoreOriginal:'还原到初始位置',
    restoreNewLocation:'还原到新位置',
    //2021-08-12添加
    backingUp:'备份中',
    restoring:'还原中',
    restore:'还原源',
    backup:'备份源',
    //2021-08-17添加
    maxNum:'源项目的最大数量为 1000，请少选项目。P.S.整个文件夹只计算一个项目。',
    maxLogs:'提示：结果被截短了。这里最多可显示1,000个失败的文件。',
    backupDetails:'备份详情',
    keepTwoFile:'保留两个文件',
    restoreDetails:'还原详情',
    longerDelete:'如果要删除大量的文件，可能需要更长时间。',
    notFoundAim:'找不到目标目录。',
    //2021-10-20
    backupNotWork:'备份服务不可用',
    //2021-10-28
    backupPartial:'备份部分成功',
    configFile:'(上传配置文件中)',
    successRestore:'成功还原所有文件。',
    notFind:'无法找到配置文件，请检查配置文件是否存在，以及云盘和MultCloud的连接是否有效。',
    selectRestoreItems: '请选择你想恢复的文件',
    selectRestoreTotles: "请选择要恢复的目录",
    original: '源云盘',
    inTotalTip: '{count}个文件，共{size}',
},
affiliateProgram: {
    leftTitle: "成为我们的经销商",
    title: "MultCloud加盟计划",
    headTips1: "赚取高达 <span>50%</span> 的佣金。",
    headTips2: "只需简单几步即可注册，绝对<span>免费</span>。",
    headTips3: "没有附加条件，<span>任何人</span>都可以成为我们的经销商！",
    signUpBtn: "注册经销商账号",
    tips: "提示：如果您已经是 Cleverbridge 的经销商，请直接<a href=\"https://console.partnerize.com/campaigns/manage-campaigns/join-campaigns/advertiser-details/1011l331\" target=\"_blank\">登入</a>。",
    howDoTipsTitle: "合作方式",
    howDoTipsMsg: "一旦注册并登录了我们的会员计划，您可以在 \"活动--加入活动 \"标签下找到AOMEI International Network Limited。点击它并确认加入。一旦加入我们的活动，您将会看到MultCloud提供的所有产品。如果有人通过您的推荐链接升级MultCloud，您将获得<span>30%-50%</span>的佣金。",
    FAQsTitle: "MultCloud 加盟计划如何运作",
    FAQ1: "加盟计划如何运作？",
    answer1: "一旦您的客户通过您的推荐页面付款，您将在下个月初获得佣金。",
    FAQ2: "听起来不错。应该如何注册？",
    answer2: "您可以通过点选上面的“注册经销商账号”进行注册。只需几步，您就可以拥有您的经销商账号。",
    answerPs2: "温馨提示：登录控制台后，您可以在\"Campains\"标签下找到AOMEI International Network Limited，顶级并确认加入。",
    FAQ3: "我能获得多少佣金？",
    answer3: "佣金因订阅方案不同而不同。例如，阅读方案对应的佣金率为30%，而终身无限版对应的佣金为50%。",
    FAQ4: "如何获得佣金？",
    answer4: "这取决于您设置的“收款方式”。佣金会在每月的月初发放给您。",
    answerPs4: "温馨提示：发放的佣金没有最低金额限制。",
    anyQuestionTitle: "您有什么问题吗？",
    anyQuestionTip: "请随时联系<a href=\"mailto:affiliate@multcloud.com\" class=\"alink\">affiliate@multcloud.com</a>",
},
signUp: {
    pwdTip: "密码 (8-16 字符)",
    signingUp: "注册 . . .",
    tips2: "通过创建一个账号, 您接受 <a href=\"https://www.multcloud.com/cn/terms\" class=\"alink\">服务条款<a/>及 <a href=\"https://www.multcloud.com/cn/policy\" class=\"alink\">隐私政策<a/>。",
    emailPushTip: "通过勾选此框，您同意接收来自MultCloud关于产品、服务更新、特别优惠及活动的电子邮件推送。您也可以在任何时候取消订阅。",
},
forgetPwd: {
    title: "忘记密码?",
    tip: "输入您的邮箱地址，然后我们将向您发送一条修改密码的链接.",
    sending: "正在发送信息 ...",
    btnTxt: "发送重置邮件",
    tips1: "忘记您的邮箱地址？",
    tips2: " 发送电子邮件给技术支持部门 ",
    tips3: "然后我们会追踪它.",
},
balackFriday: {
    lastTip: "立即参与，以免错过",
    title: "提前进入黑色星期五和网络星期一，获得无限的跨云数据流量，并享受3折优惠！",
    titleTip: "赶快行动，售完即止！",  
},
christmas: {
    payTxt: "圣诞大促销",
    popupTitle: "MULTCLOUD大促销",
    pageTitle: "以{num}%的优惠获得终身无限的跨云数据传输！",
    pageTitle2: "以{num}%的优惠获得终生无限的数据流量!",
    paysysTitle: "快点，不然就没了！",
    popupTip1: "无限的跨云数据流量",
    popupTip2: "10个高速数据传输线程",
    popupTip2Append: "高级用户享有10个线程的高速传输，免费用户享有2个线程的高速传输",
    popupTip3: "定时传输/同步/备份",
    popupTip4: "单向/双向实时同步",
    popupTip4Append: "为高级用户提供了7种额外的同步模式，支持镜像同步",
    saledBtn: "现在购买",
},
teamTransfer:{
    teamTransfer:'企业云盘传输',
    transferMultiple:'将多个账户从一个云盘平台转移到另一个平台 (Google Workspace, OneDrive for Business, Dropbox Business, Box for Business, Shared Drive).',
    businessCloud:'将多个账户从一个云盘平台转移到另一个平台 (Google Workspace, OneDrive for Business, Dropbox Business, Box for Business, Shared Drive).',
    clickSelect:'点击这里，选择您想迁移的源企业云盘。',
    sourceAccount:'来源账户',
    targetAccounts:'目标账户',
    autoMatch:'自动匹配',
    likeTransfer:'点击这里，选择您想迁移到的目标企业云盘。',
    youMust:'您必须先以管理员身份',
    cloudService:'添加',
    asAdmin:'一个企业云盘。',
    combinations:'自动匹配将清理当前的组合，您确定要继续执行吗？',
    nosourceAccount:'不存在源账户或目标账户。',
    noAccount:'不存在自动匹配的账户。',
    uploadCSV:'上传CSV文件',
    cleanCurrent :'上传CSV文件将清除当前的组合，您确定要继续执行吗？',
    csvFile:'您上传的CSV文件应符合',
    csvFormat:'.CSV格式。',
    matchCsv:'该组织不能匹配CSV文件中的任何组合，请检查CSV文件并重试。',
    alreadyAdd:'您已经添加了这两个账户的组合。',
    cleanAll:'您即将清理所有选定的组合，您确定要继续执行吗？',
    sure:'是的，我确定。',
    allTransferred:'将所有传输的文件放在一个文件夹中。',
    newTrans:'遍历开始时开始传输。',
    optionActivated:'如果该选项被激活，所有传输的文件将被保存在目标云的一个文件夹中。例如，源目录是Google Workspace\\simon@multcloud.com，目标目录是OneDrive for Business\\peter@multcloud.com，当这个选项被激活时，Google Workspace\\simon@multcloud.com中的所有文件将被迁移到OneDrive for Business\\peter@multcloud.com\\simon@multcloud.com。',
    newTransTip: '支持的任务：1. 源必须是一个文件夹 2. 源是云盘，而非电子邮件 3. 目标不是以照片为主的云盘',
    organizationMigration:'组织迁移',
    //jimin新增
    downloadCSV:'下载CSV文件',
    notSelected:'谷歌云端硬盘的共享云盘不能被选择为团队迁移任务的目标云盘。',
    batchMatch:'批量匹配',
    sourceCloud:'添加源云盘',
    targetCloud:'添加目标云盘',
    subTaskLimit:'子任务限制',
    freeUsers:'免费用户可以在一个团队迁移任务中创建3个子任务。请升级到高级版本，从而在一个团队迁移任务中创建1000个子任务。  ',
    mostTeamTransfer:'3个企业云盘传输子任务',
    substasksMost:'1000个企业云盘传输子任务',
    mostTasks:'子任务个数最多为1000个。',
    timePassed:'您所设置的时间已过。',
},
shareTransfers: {
    logoMsg: '<span class="sf-logo-first">MultCloud</span><span class="sf-logo-name"> 传输</span>',
    addFiles: '从云盘添加文件',
    trnsfering: '正在传输...',
    sendingFile: '正在发送{num}个文件',
    sendingSize: '{num}/{all}',
    sendingTip: '正在创建传输链接，请稍等。',
    cancelTransfer: '取消本次传输？',
    createdTransfer: '传输已创建！',
    createShare: '创建传输',
    signTitleByTransfer: '登录Multcloud以继续',
    signupTitleByTransfer: '注册Multcloud以继续',
    transferTitle: '标题',
    transferDescription: '描述',
    addFileTip: '已添加{num}个文件',
    titleErrMsg: '标题的长度不能超过128个字符。',
    desErrMsg: '描述不能超过512个字符',
    folder: '文件夹',
},
summerSale: {
    titleTip: '你好，夏天',
    titleTip2: '以优惠的价格获得无限的跨云数据流量，轻松管理你的夏季记忆!',
    bottomTip: '- 本季最大优惠 –',
},
halloweenSale: {
    titleTip2: '没有套路，用无限的跨云数据流量来犒劳自己，节省高达70%的费用! ',
    bottomTip: '快! 活动即将结束',
},
newYear: {
    payTxt: "新年促销",
    titleTip: "新年钟声敲响，尊享极致礼遇：无限跨云盘传输流量仅需三折！",
    bottomTip: '搞快！不然就没了！',
},
backToSchool: {
    titleTip2: '以优惠的价格获得无限的云到云数据流量并管理您所有的学校回忆！',
    bottomTip: '- 本季最大优惠 –',
},
blackFriday: {
    titleTip: '3折畅享无限的跨云盘传输流量。',
    bottomTip: '搞快！不然就没了！',
},
xmas: {
    titleTip: '圣诞尊享：无限跨云盘传输流量仅需三折！',
    bottomTip: '搞快！不然就没了！',
},
license: {
    codeTitle: '输入注册码',
    codeTipTitle: '输入注册码',
    codeTipText: '如果您有注册码，可以使用它来激活付费服务。',
    codeTipTextVip: '如果您有注册码，可以使用它来升级服务。',
    codeFooter: '如果您需要任何帮助，请随时联系： ',
    showTitle: '注册码',
    showTip: '注册码为：',
    codeSucTitle: '高级服务已激活',
    codeSucTip: '高级服务已激活！',
},
filters: {
    taskList: {
        typeName: '输入',
        type: {
            all: '所有列表',
            copy: '临时任务',
            transfer: '跨云盘传输',
            sync: '跨云盘同步',
            backup: '云备份',
            business: '企业云盘传输',
            remoteUpload: '离线上传',
            emailMigration: '邮件传输',
        },
        statusName: "状态",
        status: {
            all: "所有状态",
            preset: '预设',
            running: '进行中',
            success: '成功',
            patial: '部分成功',
            failed: '失败',
            canceled: '取消',
        },
        dateName: "日期",
        date: {
            all: '所有日期',
            today: '今天',
            latestWeek: '上周',
            latestMonth: '上个月',
            customDate: '自定义日期',
        },
    }
},
schedule: {
    week1: "星期日",
    week2: "星期一",
    week3: "星期二",
    week4: "星期三",
    week5: "星期四",
    week6: "星期五",
    week7: "星期六",
},
inputTab: {
    filterMessage: '按回车键Enter添加文件扩展名',
}
}



// WEBPACK FOOTER //
// ./src/assets/i18n/chinese.js